import { useForm, Controller, useFieldArray } from "react-hook-form";
import React, { useState, useEffect, useRef } from "react";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import Grid from "@mui/material/Grid";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Checkbox from "@mui/material/Checkbox";
import Button from "@mui/material/Button";
import MDBox from "../../../components/MDBox/index";
import MDInput from "components/MDInput";
import SelectDropDown from "../../../examples/DropDown/index";
import MDButton from "components/MDButton";
import NestedArray from "./nestedFieldArray";
import Moment from "moment";
import AddIcon from "@mui/icons-material/Add";
import {
  DialogContent,
  Typography,
  FormControlLabel,
  FormGroup,
  Link,
  TextField,
  IconButton,
  MenuItem,
  ListItemIcon,
  ListItemText,
  Select,
  CircularProgress,
  Tabs,
  Tab,
  Box,
  Card,
  Divider,
  InputAdornment,
  RadioGroup,
  Radio,
  Autocomplete,
} from "@mui/material";
import ArrowBackIos from "@mui/icons-material/ArrowBackIos";
import CloudUpload from "@mui/icons-material/CloudUpload";
import DescriptionIcon from "@mui/icons-material/Description";
import VisibilityIcon from "@mui/icons-material/Visibility";
import DeleteIcon from "@mui/icons-material/Delete";

import InputForm from "./InputForm";
import { Paper } from "@mui/material";
import { yupResolver } from "@hookform/resolvers/yup";
import { hospitalBranchFormValidation } from "util/validations/hospitalPanelValidation";
import { Navigate, useNavigate, useParams } from "react-router-dom";
import {
  GetHospitalBranchById,
  setDocumentType,
  UpdateHospital,
} from "../Redux/actionCreator";
import { getCompanyList } from "layouts/hospital/Redux/actionCreator";
import { useDispatch, useSelector } from "react-redux";
import SelectDropDownNew from "examples/DropDownNew";
import { getHospitalBranchById } from "services/hospitalServices";
import DynamicCoords from "examples/DynamicCoords";
import DynamicDocuments from "examples/DynamicDocuments";
import { setOrganizationsDropdown } from "layouts/common/Redux/actionCreator";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { CompressOutlined, Edit, X } from "@mui/icons-material";
import { setProfessionType } from "layouts/events/Redux/actionCreator";
import { setSpecialisationsType } from "layouts/events/Redux/actionCreator";
import { setUsersDropdown } from "layouts/common/Redux/actionCreator";
import { id } from "date-fns/locale";
import MultiSelectDropdown from "examples/Multi Select Dropdown";
import Questions from "./Questions";
import { setCityList } from "layouts/events/Redux/actionCreator";
import { setPhoto } from "../../../layouts/events/Redux/actionCreator";
import ConfirmDialog from "../ConfirmDialog";

import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { toast } from "react-toastify";
const label = { inputProps: { "aria-label": "Checkbox demo" } };

const BranchUserForm = () => {
  const [branchData, setBranchData] = useState([]);
  const [activeTab, setActiveTab] = useState(0);
  // Refs for file inputs
  const gstFileInputRef = useRef(null);
  const panFileInputRef = useRef(null);
  const tanFileInputRef = useRef(null);
  const cancelChequeRef = useRef(null);
  const contractFileInputRef = useRef(null);
  const declerationFileInputRef = useRef(null);
  const gstErrorShown = useRef(false);

  const [tabValue, setTabValue] = useState(0);

  const [openConfirm, setOpenConfirm] = useState(false);
  const [newMode, setNewMode] = useState("");
  const [oldMode, setOldMode] = useState("");
  const [confirmMessage, setConfirmMessage] = useState("");

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
    setActiveTab(newValue);
  };
  // State for uploaded files
  const [uploadedFiles, setUploadedFiles] = useState({
    gst: null,
    pan: null,
    tan: null,
    cancelCheque: null,
    contract: [],
    decleration: null,
  });

  // Handle file upload
  const handleFileUpload = (e, type, contractIndex = null) => {
    const file = e.target.files[0];
    console.log("file", file);
    console.log("type", e);

    if (!file) return;

    const fileSizeInMB = file.size / (1024 * 1024);
    const maxSizeMB = 5;

    // Validate file type
    const validTypes = [
      "application/pdf",
      "image/jpeg",
      "image/jpg",
      "image/png",
    ];
    if (!validTypes.includes(file.type)) {
      alert("Invalid file type. Please upload a PDF, JPG, or PNG file.");
      return;
    }

    // Validate file size
    if (fileSizeInMB > maxSizeMB) {
      alert(`File size exceeds ${maxSizeMB}MB limit.`);
      return;
    }

    // const fileUrl = URL.createObjectURL(file);
    // setSelectedFileName(file.name);
    dispatch(setPhoto(file)).then((response) => {
      console.log("response", response);

      const fileUrl = response.payload?.data?.data[0]?.url;
      // Assuming the response contains the URL or other information
      // console.log("File Upload Response:", response.payload.data.data[0].url);
      // const logoUrl = response.payload.data;
      // console.log("url", logoUrl);
      // Assuming data.client.logo is an array
      // setValue("client.logo", logoUrl);

      if (type.startsWith("contract_")) {
        const index = type.split("_")[1];
        setUploadedFiles((prev) => ({
          ...prev,
          [`contract_${index}`]: {
            name: file.name,
            size: file.size,
            type: file.type,
            url: fileUrl,
            file: file,
          },
        }));
        setValue(`contractDetails.${index}.contractCopy.fileUrl`, fileUrl);
      } else {
        setUploadedFiles((prev) => ({
          ...prev,
          [type]: {
            name: file.name,
            size: file.size,
            type: file.type,
            url: fileUrl,
            file: file,
          },
        }));

        // Set the corresponding form field
        switch (type) {
          case "gst":
            setValue("gstCertificateUrl", fileUrl);
            break;
          case "pan":
            setValue("panCertificateUrl", fileUrl);
            break;
          case "tan":
            setValue("tanCertificateUrl", fileUrl);
            break;
          case "cancelCheque":
            setValue("cancelledChequeUrl", fileUrl);
            break;
          case "decleration":
            setValue("declerationUrl", fileUrl);
            break;
        }
      }
    });
    // alert('File uploaded successfully!');
  };

  // Handle file remove
  const handleFileRemove = (type) => {
    if (type.startsWith("contract_")) {
      const index = type.split("_")[1];
      setUploadedFiles((prev) => {
        const newFiles = { ...prev };
        delete newFiles[`contract_${index}`];
        return newFiles;
      });
      setValue(`contractDetails.${index}.contractCopy.fileUrl`, "");

      // Clear the file input
      const input = document.querySelector(
        `input[type="file"][data-type="${type}"]`
      );
      if (input) input.value = "";
    } else {
      setUploadedFiles((prev) => {
        const newFiles = { ...prev };
        delete newFiles[type];
        return newFiles;
      });

      // Clear the corresponding form field and input
      switch (type) {
        case "gst":
          setValue("gstCertificateUrl", "");
          if (gstFileInputRef.current) gstFileInputRef.current.value = "";
          setValue("billingDetails.gstDocument", null);
          break;
        case "pan":
          setValue("panCertificateUrl", "");
          if (panFileInputRef.current) panFileInputRef.current.value = "";
          setValue("billingDetails.panDocument", null);
          break;
        case "tan":
          setValue("tanCertificateUrl", "");
          if (tanFileInputRef.current) tanFileInputRef.current.value = "";
          setValue("billingDetails.tanDocument", null);
          break;
        case "cancelCheque":
          setValue("cancelledChequeUrl", "");
          if (cancelChequeRef.current) cancelChequeRef.current.value = "";
          setValue("bankDetails.cancelCheque", null);
          break;
        case "decleration":
          setValue("declerationUrl", "");
          if (declerationFileInputRef.current)
            declerationFileInputRef.current.value = "";
          setValue("billingDetails.declerationDocument", null);
          break;
      }
    }

    // alert('File removed successfully!');
  };
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const params = useParams();

  const { hospital_Id_Data } = useSelector((state) => state.hospital);
  const { UsersData } = useSelector((state) => state.common);
  const { City_List_Data } = useSelector((state) => state.events);
  const [inputList, setInputList] = useState([]);

  const cityData = City_List_Data?.cityListInfo;
  const cityOptions = [];

  cityData.map((ele) => {
    let obj = {
      key: ele.name,
      value: ele.name,
    };
    cityOptions.push(obj);
  });

  useEffect(() => {
    dispatch(GetHospitalBranchById(params?.branchName));
  }, []);

  // handle input change
  const handleInputChange = (e, index) => {
    const { name, value } = e.target;
    const list = [...inputList];
    list[index][name] = value;
    setInputList(list);
  };

  // handle click event of the Remove button
  const handleRemoveClick = (index) => {
    const list = [...inputList];
    list.splice(index, 1);
    setInputList(list);
  };

  const handleAddClick = () => {
    setInputList([...inputList, { firstName: "" }]);
  };
  const [passwordButton, setPasswordButton] = useState(true);

  const selectOptions = [
    {
      key: "Company",
      value: "Company",
    },
  ];

  const selectedReversedOption = [
    {
      key: "YES",
      value: "YES",
    },
    {
      key: "NO",
      value: "NO",
    },
  ];

  const selectedBedSizeOption = [
    {
      key: "0-50",
      value: "0-50",
    },
    {
      key: "50-100",
      value: "50-100",
    },
    {
      key: "100-250",
      value: "100-250",
    },
    {
      key: "250-500",
      value: "250-500",
    },
    {
      key: "500+",
      value: "500+",
    },
  ];


  const selectedPaymentTypeOption = [
    {
      key: "FULL_PAYMENT",
      value: "FULL_PAYMENT",
    },
    {
      key: "PARTIAL_PAYMENT",
      value: "PARTIAL_PAYMENT",
    },
  ];

  const shiftOptions = [
    {
      key: "EARLY_MORNING",
      value: "EARLY_MORNING",
    },
    {
      key: "MORNING",
      value: "MORNING",
    },
    {
      key: "AFTERNOON",
      value: "AFTERNOON",
    },
    {
      key: "EVENING",
      value: "EVENING",
    },
    {
      key: "NIGHT",
      value: "NIGHT",
    },
    {
      key: "DAY_NIGHT",
      value: "DAY_NIGHT",
    },
    {
      key: "ALL_DAY",
      value: "ALL_DAY",
    },
  ];

  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;

  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
    getContentAnchorEl: null,
    anchorOrigin: {
      vertical: "bottom",
      horizontal: "center",
    },
    transformOrigin: {
      vertical: "top",
      horizontal: "center",
    },
    variant: "menu",
  };

  const notInterestedInfo = UsersData?.usersInfo;
  const notInterestedOptions = [];

  notInterestedInfo.map((ele) => {
    let obj = {
      key: ele._id,
      value: ele.name,
    };

    notInterestedOptions.push(obj.value);
  });

  const options = notInterestedOptions;

  const days = [
    { key: "Monday", value: "Monday" },
    { key: "Tuesday", value: "Tuesday" },
    { key: "Wednesday", value: "Wednesday" },
    { key: "Thursday", value: "Thursday" },
    { key: "Friday", value: "Friday" },
    { key: "Saturday", value: "Saturday" },
    { key: "Sunday", value: "Sunday" },
  ];

  const [selectedDays, setSelectedDays] = useState([]);
  const [daysID, setDaysID] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [modalType, setModalType] = useState("");
  const [modalMessage, setModalMessage] = useState("");

  const isAllSelectedDays =
    options.length > 0 && selectedDays.length === options.length;

  const handleChangeDays = (event, index) => {
    const value = event.target.value;
    if (value[value.length - 1] === "all") {
      setSelectedDays(selectedDays.length === options.length ? [] : options);
      return;
    }
    setSelectedDays(value);
    setDaysID((current) => [...current, value]);
  };

  const [companyID, setCompanyID] = useState("");
  const [organizationID, setOrganizationID] = useState("");
  const [responseData, setResponseData] = useState([]);
  const [specializationID, setSpecializationID] = useState([]);
  const [branchInActivated, setBranchInActivated] = useState(false);
  const [branchActivated, setBranchActivated] = useState(false);
  const { Profession_Type_Data, Specialization_Type_Data } = useSelector(
    (state) => state.events
  );
  const { hospital_company_Data } = useSelector((state) => state.hospital);
  const { OrganizationsData } = useSelector((state) => state.common);

  const companyData = hospital_company_Data?.companyInfo;
  const specializationsData = Specialization_Type_Data?.specializationInfo;
  const organizationInfo = OrganizationsData?.organizationsInfo;
  const professionData = Profession_Type_Data?.professionInfo;

  const companyOptions = [];
  const organizationOptions = [];

  const professionOptions = [];
  const specializationOptions = [];

  specializationsData.map((ele) => {
    let obj = {
      key: ele._id,
      value: ele.name,
    };
    specializationOptions.push(obj);
  });

  organizationInfo.map((ele) => {
    let obj = {
      key: ele._id,
      value: ele.name,
    };

    organizationOptions.push(obj);
  });

  companyData.map((ele) => {
    let obj = {
      key: ele._id,
      value: ele.name,
    };

    companyOptions.push(obj);
  });

  professionData.map((ele) => {
    let obj = {
      key: ele._id,
      value: ele.name,
    };

    professionOptions.push(obj);
  });

  const testPapers = [];
  const [testPaper, setTestPaper] = useState([]);
  const handleSpecializationChange = (e) => {
    let userID;
    specializationOptions.map((obj) => {
      if (obj.value == e.target.value) {
        testPapers.push(obj.key);
        userID = obj.key;
        setTestPaper([...testPaper, obj.key]);
      }
    });

    setSpecializationID((current) => [...current, userID]);
  };

  const handleCandidateTypeChange = (e) => {
    setValue("candidateType.name", e.target.value);
    let userID;
    //Searching for the name in the Users array to find the ID
    professionOptions.map((obj) => {
      if (obj.value == e.target.value) {
        userID = obj.key;
      }
    });

    setCandidateTypeID(userID);
  };

  const handleCompanyChange = (e) => {
    setValue("company.name", e.target.value);
    let userID;
    //Searching for the name in the Users array to find the ID
    companyOptions.map((obj) => {
      if (obj.value == e.target.value) {
        userID = obj.key;
      }
    });

    setCompanyID(userID);
  };

  const handleOrganizationChange = (e) => {
    setValue("organization.name", e.target.value);
    let userID;
    //Searching for the name in the Users array to find the ID
    organizationOptions.map((obj) => {
      if (obj.value == e.target.value) {
        userID = obj.key;
      }
    });

    setOrganizationID(userID);
  };

  const convert = (str) => {
    var date = new Date(str),
      month = ("0" + (date.getMonth() + 1)).slice(-2),
      day = ("0" + date.getDate()).slice(-2);

    return [day, month, date.getFullYear()].join("-");
  };
  const closeModal = () => {
    if (modalType === "success" || modalType === "success_inactive") {
      setShowModal(false);
      setModalType("");
      setModalMessage("");
      navigate("/hospital/branch");
    } else {
      setShowModal(false);
      setModalType("");
      setModalMessage("");
    }
  };

  const ID = window.location.href.split("branch")[1].split("/")[1];

  const [adStartDateChange, setAdStartDateChange] = useState(true);
  const [adEndDateChange, setAdEndDateChange] = useState(true);
  const [eventStartDateChange, setEventStartDateChange] = useState(false);
  const [eventEndDateChange, setEventEndDateChange] = useState(false);
  const [adStartDate, setAdStartDate] = useState(null);
  const [datee, setDate] = useState(null);
  const [adEndDate, setAdEndDate] = useState(null);
  const [eventStartDate, setEventStartDate] = useState(null);
  const [eventEndDate, setEventEndDate] = useState(null);
  const [isOneTimeFee, setisOneTimeFee] = useState(false);

  const [eventDate, setEventDate] = useState(null);
  const [gstAvailable, setGstAvailable] = useState("");

  var dayyy = new Date(datee);
  var nextDay = new Date(dayyy);
  nextDay.setDate(dayyy.getDate() + 1);

  var eventDatee = new Date(eventDate);
  var nextDayy = new Date(eventDatee);
  nextDayy.setDate(eventDatee.getDate() + 1);

  const today = new Date();

  const getData = async () => {
    let response = await getHospitalBranchById(ID);

    setResponseData(response);

    return response[0];
  };

  console.log("responseData", responseData);
  // const paymentMode = responseData[0]?.billingInfo?.billingMode;
  const isNewBranch = responseData[0]?.isNewBranch;
  console.log("isNewBranch", isNewBranch);
  const {
    register,
    setValue,
    handleSubmit,
    control,
    getValues,
    watch,
    reset,
    trigger,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(hospitalBranchFormValidation),
    mode: "onSubmit",
    defaultValues: async () => ({
      ...(await getData()),
      contractDetails: [
        {
          contractStartDate: "",
          contractEndDate: "",
          contractCopy: { fileUrl: "" },
          isActive: false,
        },
      ],
      isNewBranch: false,
    }),
  });
  const {
    fields: contractFields,
    append: appendContract,
    remove: removeContract,
  } = useFieldArray({
    control,
    name: "contractDetails",
  });
  const {
    fields: testField,
    append: testAppend,
    remove: testRemove,
  } = useFieldArray({
    control,
    name: "testPapers",
  });
  const {
    fields: shiftField,
    append: shiftAppend,
    remove: shiftRemove,
  } = useFieldArray({
    control, // control props comes from useForm (optional: if you are using FormContext)
    name: "shifts", // unique name for your Field Array
  });
  const {
    fields: docField,
    append: docAppend,
    remove: docRemove,
  } = useFieldArray({
    control, // control props comes from useForm (optional: if you are using FormContext)
    name: "documents", // unique name for your Field Array
  });
  const {
    fields: contactField,
    append: contactAppend,
    remove: contactRemove,
  } = useFieldArray({
    control,
    name: "contactDetails",
  });

  const {
    fields: coordField,
    append: coordAppend,
    remove: coordRemove,
  } = useFieldArray({
    control, // control props comes from useForm (optional: if you are using FormContext)
    name: "billingAddress.address.coords", // unique name for your Field Array
  });

  const {
    fields: CoordInField,
    remove: CoordInRemove,
    append: CoordInAppend,
  } = useFieldArray({
    control,
    name: `contact.nestedArray`,
  });

  const [candidateTypeID, setCandidateTypeID] = useState("");
  const [daysData, setDaysData] = useState([]);
  const { documentTypeDropDown } = useSelector((state) => state.hospital);
  const docTypeData = documentTypeDropDown?.documentTypeDropDownInfo;
  const docTypeOptions = [];

  docTypeData.map((ele) => {
    let obj = {
      key: ele._id,
      value: ele.name,
    };

    docTypeOptions.push(obj);
  });

  const conditionalValidate = (validateFn) => {
    return (value) => {
      if (!isNewBranch) return true; // Skip validation if not a new branch
      return validateFn(value);
    };
  };

  const handleConfirm = () => {
    setOpenConfirm(false);

    // Update the form value safely AFTER confirmation
    setValue("billingMode", newMode);
  };

  const handleCancel = () => {
    setOpenConfirm(false);
    setNewMode("");
  };



  const onSubmit = async (data) => {
    // if (data.isOneTimeFee && (!data.oneTimeFeeAmount || data.oneTimeFeeAmount === '')) {
    //   setModalType("error");
    //   setModalMessage("One Time Fee Amount is required");
    //   setShowModal(true);
    //   return;
    // }

    console.log("data", data);
    const gstNumber = data?.gstNumber || data?.billingAddress?.gstNumber;
    const gstRegex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z][1-9A-Z]Z[0-9A-Z]$/;
    const gstAvailable = data?.isGSTAvailable;
    if (gstAvailable === "yes" && !gstNumber) {
      toast.error("GST Number is required");
      return;
    }
    if (gstNumber) {
        if (!gstRegex.test(gstNumber)) {
          toast.error("Invalid GST Number format");
          return;
        }
        const selectedState = data?.billingState;
        const expectedCode = stateCodes?.[selectedState];

        if (expectedCode && gstNumber.length >= 2) {
          const gstCode = gstNumber.substring(0, 2);

          if (gstCode !== expectedCode) {
            toast.error(
              `GST should start with  ${expectedCode} for ${selectedState}`
            );
            return;
          }
        }
      }
    const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]$/
    if (data?.panNumber) {
      if (!panRegex.test(data?.panNumber)) {
        toast.error("Invalid PAN Number format");
        return;
      }
    }
    const tanRegex = /^[A-Z]{4}[0-9]{5}[A-Z]$/
    if(data?.tanNumber){
      if(!tanRegex.test(data?.tanNumber)){
        toast.error("Invalid TAN Number format");
        return;
      }
    }
    const ifscRegex = /^[A-Z]{4}0[A-Z0-9]{6}$/
    if(data?.ifscCode){
      if(!ifscRegex.test(data?.ifscCode)){
        toast.error("Invalid IFSC Code format");
        return;
      }
    }
    if (data.contractDetails[0]?.contractCopy?.fileUrl) {
      // const hrEmail = data.hrEmail || getValues('hrEmail');
      // const startDate = data.contractDetails[0].contractStartDate;
      // const endDate = data.contractDetails[0].contractEndDate;
      // const financeEmail = data.financeEmail || getValues('financeEmail');

      //   if (!hrEmail  || !startDate || !endDate ) {
      //     console.log('Cannot save: Both HR emails are required when contracts are present');
      //     setModalType("error_email");
      //     setModalMessage("Please fill in the following required fields: \nHR Email ID");
      //     setShowModal(true);
      //     return;
      //   }
      // }
      const hrEmail = data.hrEmail || getValues("hrEmail");
      const startDate =
        data.contractDetails[0].contractStartDate ||
        getValues(`contractDetails[0].contractStartDate`);
      const endDate =
        data.contractDetails[0].contractEndDate ||
        getValues(`contractDetails[0].contractEndDate`);
      const contractCopy =
        data?.contractDetails[0]?.contractCopy?.fileUrl ||
        getValues(`contractDetails[0].contractCopy.fileUrl`);
      if (contractCopy) {
        if (!hrEmail || !startDate || !endDate) {
          console.log(
            "Cannot save: Both HR emails are required when contracts are present"
          );
          setModalType("error_email");
          setModalMessage(
            <div>
              <div>Please fill in the following required fields:</div>
              <div style={{ marginTop: "8px" }}>
                <div>
                  • <strong>HR Email ID</strong>
                </div>
                <div>
                  • <strong>Contract Start Date</strong>
                </div>
                <div>
                  • <strong>Contract End Date</strong>
                </div>
              </div>
            </div>
          );
          setShowModal(true);
          return;
        }
      }
    }
    const invalidContract = data.contractDetails.some((contract) => {
      // const hrEmail = data.hrEmail || getValues('hrEmail');
      const startDate = contract?.contractStartDate;
      const endDate = contract?.contractEndDate;
      // const contractCopy = contract?.contractCopy?.fileUrl;
      // if (contractCopy){
      //   if (!hrEmail  || !startDate || !endDate ) {
      //     console.log('Cannot save: Both HR emails are required when contracts are present');
      //     setModalType("error_email");
      //     setModalMessage(
      //       <div>
      //     <div>Please fill in the following required fields:</div>
      //     <div style={{ marginTop: '8px' }}>
      //     <div>• <strong>HR Email ID</strong></div>
      //     <div>• <strong>Contract Start Date</strong></div>
      //     <div>• <strong>Contract End Date</strong></div>
      //     </div>
      //   </div>
      //     );
      //     setShowModal(true);
      //     return;
      //   }
      // }
      if (startDate && endDate && new Date(startDate) >= new Date(endDate)) {
        setModalType("error_date");
        setModalMessage(
          "Contract end date must be after start date for all contracts"
        );
        setShowModal(true);
        return true;
      }
      return false;
    });

    if (invalidContract) {
      return; // Stop submission if any contract has invalid dates
    }
    const shiftData = [];
    const testData = [];
    let documentsData = [];
    data?.documents.map((obj) => {
      let DocObj = {
        docType:
          typeof obj?.docType == "object"
            ? obj?.docType?.name == "undefined"
              ? ""
              : obj?.docType?._id
            : obj?.docType,
        files: obj?.files,
        uploadedAt: obj?.uploadedAt,
      };
      documentsData.push(DocObj);
    });
    data?.testPapers.map((obj) => {
      let testPaperObj = {
        for: typeof obj?.for == "object" ? "" : obj?.for,
        questions: obj?.questions,
      };
      testData.push(testPaperObj);
    });
    const coordData = [];
    const addressCoords = [];
    data?.shifts.map((obj) => {
      let shiftObj = {
        shiftType: obj.shiftType,
        profession: typeof obj.profession == "object" ? "" : obj.profession,
        startTime: obj?.startTime,
        endTime: obj?.endTime,
      };
      shiftData.push(shiftObj);
    });
    data?.billingAddress.address.coords.map((elem) => {
      if (typeof elem == "object") {
        addressCoords.push("");
      } else {
        addressCoords.push(elem);
      }
    });
    const contactDetailPayload = [];
    data?.contactDetails.map((ele) => {
      if (
        new Date(Date.parse(ele?.contactTimeStart)) ==
        new Date(ele?.contactTimeStart).toUTCString()
      )
        ele.contactTimeStart = null;
      const addressCoords = [];

      ele?.address?.coords.map((elem) => {
        if (typeof elem == "object") {
          addressCoords.push("");
        } else {
          addressCoords.push(elem);
        }
      });
      let obj = {
        address: {
          address: ele?.address?.address,
          city: ele?.address?.city,
          coords: addressCoords,
          country: ele?.address?.country,
          pin: ele?.address?.pin,
          state: ele?.address?.state,
        },
        email: ele?.email,
        phone: ele?.phone,
        contactDays: ele?.contactDays,
        // contactTimeStart:isIsoDate(ele?.contactTimeStart) ?(ele?.contactTimeStart):null,
        // contactTimeEnd:isIsoDate(ele?.contactTimeEnd) ?(ele?.contactTimeEnd):null
        contactTimeStart: ele?.contactTimeStart,
        contactTimeEnd: ele?.contactTimeEnd,
      };
      contactDetailPayload.push(obj);
    });

    console.log("data>>", data);
    console.log("uploadedFiles", uploadedFiles);
    const payload = {
      jobLocation: {
        branchName: data?.name,
      },
      // jobLocation: {
      //   branchName: data?.jobLocation?.branchName,
      // },
      isDeleted: data?.isDeleted,
      organization: organizationID, //
      company: companyID, //
      brand: data?.brand, //
      subBrand: data?.subBrand, //
      isBillingEntity: data?.isBillingEntity === "true" ? true : false,
      billingAddress: {
        address: {
          coords: addressCoords,
          address: data?.billingAddress?.address?.address,
          city: data?.billingAddress?.address?.city,
          state: data?.billingAddress?.address?.state,
          country: data?.billingAddress?.address?.country,
          pin: data?.billingAddress?.address?.pin,
        },
        gstNumber: data?.billingAddress?.gstNumber,
        isGstRegistered: data?.billingAddress?.isGstRegistered,
      },
      jobLocation: {
        branchName: data?.jobLocation?.branchName,
        hospitalName: data?.jobLocation.hospitalName,
        address: {
          address: data?.jobLocation.address.address,
          city: data?.jobLocation.address.city,
          state: data?.jobLocation.address.state,
          pin: data?.jobLocation.address.pin,
          country: data?.jobLocation.address.country,
          lat: data?.jobLocation.address.lat,
          long: data?.jobLocation.address.long,
        },
      },
      isJobApprovalRequired: data?.isJobApprovalRequired,
      isTestRequired: data?.isTestRequired,
      reverseChargesApplicable: data?.reverseChargesApplicable,
      bedSize: data?.bedSize,
      // created_at: data?.created_at,
      // updated_at: data?.updated_at,
      contactDetails: contactDetailPayload,
      documents: documentsData,
      shifts: shiftData,
      testPapers: testData,
      shiftApproval: data?.shiftApprovalBufferDays,
      latePaymentFeePercent: data?.latePaymentFeePercent,
      platformFeePercent: data?.platformFeePercent,
      additionalFeesAndDiscounts: {
        isOneTimeFee: data?.isOneTimeFee === "true" ? true : false,
        oneTimeFeeAmount: data?.oneTimeFeeAmount,
        discountCoupon: data?.discountCoupon,
      },
      branchActivated: data?.branchActivated,
      branchInactive: data?.branchInactive,
      billingInfo: {
        contactPhones: {
          hr: data?.hrContact || "",
          finance: data?.financeContact || "",
          // Convert comma-separated string to array for other contacts
          others: data?.otherPhone
            ? data.otherPhone
                .split(",")
                .map((item) => item.trim())
                .filter(Boolean)
            : [],
        },
        serviceFeePercent: data?.serviceFeePercent,
        billingMode: data?.billingMode,
        billingCycle: data?.billingCycle,
        paymentDuePeriodDays: data?.paymentDuePeriodDays,
        bufferDays: data?.bufferDays,
        // shiftApprovalBufferDays: data?.shiftApprovalBufferDays,
        billingEmails: {
          hr: data?.hrEmail || "",
          finance: data?.financeEmail || "",
          // Convert comma-separated string to array for other emails
          others: data?.otherEmail
            ? data.otherEmail
                .split(",")
                .map((item) => item.trim())
                .filter(Boolean)
            : [],
        },
        gstDetails: {
          billingName: data?.billingName,
          billingAddress: data?.completeBillingAddress,
          billingCity: data?.billingCity,
          billingState: data?.billingState,
          billingPinCode: data?.billingPinCode,
          billingCountry: data?.billingCountry,
          gstNumber: data?.gstNumber,
          gstCertificate: uploadedFiles.gst
            ? {
                fileUrl: uploadedFiles.gst.url || "",
              }
            : { fileUrl: "" },
          panNumber: data?.panNumber,
          panCertificate: uploadedFiles.pan
            ? {
                fileUrl: uploadedFiles.pan.url || "",
              }
            : { fileUrl: "" },
          tanNumber: data?.tanNumber,
          tanCertificate: uploadedFiles.tan
            ? {
                fileUrl: uploadedFiles.tan.url || "",
              }
            : { fileUrl: "" },
          declarationData: uploadedFiles.decleration
            ? {
                fileUrl: uploadedFiles.decleration.url || "",
              }
            : { fileUrl: "" },
          isGSTAvailable:
            gstAvailable === "yes" ? "YES" : gstAvailable === "no" ? "NO" : "",
          isGstRegistered: data?.isGstRegistered === "true" ? true : false,
        },

        bankDetails: {
          branchName: data?.branchName,
          bankName: data.bankName,
          accountNumber: data.accountNumber,
          accountHolderName: data.accountHolderName,
          ifscCode: data.ifscCode,
          cancelledCheque: uploadedFiles.cancelCheque
            ? {
                fileUrl: uploadedFiles.cancelCheque.url || "",
              }
            : { fileUrl: "" },
        },
        contractDetails: contractFields
          .map((field, index) => {
            const startDate = getValues(
              `contractDetails.${index}.contractStartDate`
            );
            const endDate = getValues(
              `contractDetails.${index}.contractEndDate`
            );
            const fileUrl = getValues(
              `contractDetails.${index}.contractCopy.fileUrl`
            );

            // Skip if no data is provided for this contract
            if (
              !startDate &&
              !endDate &&
              !uploadedFiles[`contract_${index}`] &&
              !fileUrl
            ) {
              return null;
            }

            return {
              contractCopy: uploadedFiles[`contract_${index}`]
                ? {
                    fileUrl: uploadedFiles[`contract_${index}`].url || "",
                  }
                : { fileUrl: fileUrl || "" },
              contractStartDate: startDate,
              contractEndDate: endDate,
            };
          })
          .filter(Boolean),
      },
      paymentType: data?.paymentType,
      updatedFrom: "Through_Branch",

      // branchActivated: true,
      // shiftApproval: data?.shiftApproval
    };

    // console.log("payload>>>", payload);
    try {
      const res = await dispatch(
        UpdateHospital({ payload: payload, id: params?.branchName })
      );
      console.log("resData", res);
      console.log("responseData====", responseData[0].branchInactive);
      let response = await getHospitalBranchById(ID);
      if (response[0]?.branchActivated === true) {
        console.log("branch activated");
        setModalType("success");
        setModalMessage(
          "Your branch is now active. To start posting jobs, please create departments, set up rate cards, and assign users."
        );
        setShowModal(true);
        // navigate("/hospital/branch");
      } else if (response[0]?.branchInactive === true) {
        console.log("branch inactivated");
        setModalType("success_inactive");
        setModalMessage(
          "This branch has been successfully inactivated. Job posting is now disabled until the branch is reactivated."
        );
        setShowModal(true);
      } else {
        setModalType("error");
        await getData();
        setModalMessage(
          "All mandatory fields must be filled to activate this branch."
        );
        setShowModal(true);
        console.log("branch not activated");
      }
    } catch (error) {
      console.log("error", error);
    }

    // dispatch(UpdateHospital({ payload: payload, id: params?.branchName })).then(
    //   () => {
    //     try {
    //       navigate("/hospital/branch");
    //     } catch (error) {
    //       console.log("error", error)
    //     }
    //   }
    // );
  };
  console.log("modalType", modalType, showModal);

  const handleReset = () => {
    reset();
  };
  const handleBack = () => {
    navigate(-1);
  };
  useEffect(() => {
    setBranchData(hospital_Id_Data?.hospitalIdInfo || []);
  }, [hospital_Id_Data]);

  useEffect(() => {
    dispatch(getCompanyList());
    dispatch(setSpecialisationsType());
    dispatch(setProfessionType());
    dispatch(setDocumentType());
    dispatch(setOrganizationsDropdown());
    dispatch(setUsersDropdown());
    dispatch(setCityList());
  }, []);

  useEffect(() => {
    if (responseData[0]?.billingInfo?.gstDetails?.isGSTAvailable === "YES") {
      setGstAvailable("yes");
    }
    if (responseData[0]?.billingInfo?.gstDetails?.isGSTAvailable === "NO") {
      setGstAvailable("no");
    }
  }, [responseData]);

  const [updateCreated, setUpdateCreated] = useState(false);
  const [updateUpdated, setUpdateUpdated] = useState(false);
  const [datee1, setDatee1] = useState("");
  const [datee2, setDatee2] = useState("");
  const [startDate, setStartDate] = useState([]);

  useEffect(() => {
    const created = getValues("createdAt");
    const updated = getValues("updatedAt");

    const reverse = getValues("reverseChargesApplicable");
    if (created == "Invalid date") {
      setValue("createdAt", "");
    }
    if (updated == "Invalid date") {
      setValue("updatedAt", "");
    }

    if (created !== undefined && created !== "") {
      if (!updateCreated) {
        setValue("createdAt", Moment(created).format("DD/MM/YYYY"));
        setUpdateCreated(true);
      }
    }

    if (updated !== undefined && updated !== "") {
      if (!updateUpdated) {
        setValue("updatedAt", Moment(created).format("DD/MM/YYYY"));
        setUpdateUpdated(true);
      }
    }
  }, [
    getValues("createdAt"),
    getValues("updatedAt"),
    getValues("reverseChargesApplicable"),
    getValues("bedSize"),
    getValues("createdBy"),
    getValues("updatedBy"),
    // getValues("contactDetails")
  ]);

  useEffect(() => {
    const data = getValues("contactDetails");

    data.map((elem, index) => {
      if (elem?.contactTimeStart !== null && elem?.contactTimeEnd !== null) {
        if (elem?.contactTimeStart?.ts) {
          let startDate = new Date(
            parseInt(elem?.contactTimeStart?.ts)
          ).toISOString();

          setValue(`contactDetails.[${index}].contactTimeStart`, startDate);
        }
        if (elem?.contactTimeEnd?.ts) {
          let endDate = new Date(
            parseInt(elem?.contactTimeEnd?.ts)
          ).toISOString();
          setValue(`contactDetails.[${index}].contactTimeEnd`, endDate);
        }
      } else {
        setValue(`contactDetails.[${index}].contactTimeStart`, null);
        setValue(`contactDetails.[${index}].contactTimeEnd`, null);
      }
    });
  }, [getValues("contactDetails")]);

  const formValues = getValues();
  useEffect(() => {
    if (responseData[0]?.billingInfo) {
      setValue(
        "serviceFeePercent",
        responseData[0]?.billingInfo?.serviceFeePercent
      );
      setValue("billingMode", responseData[0]?.billingInfo?.billingMode);
      setValue("billingCycle", responseData[0]?.billingInfo?.billingCycle);
      setValue(
        "paymentDuePeriodDays",
        responseData[0]?.billingInfo?.paymentDuePeriodDays
      );
      setValue("bufferDays", responseData[0]?.billingInfo?.bufferDays);
      setValue("shiftApprovalBufferDays", responseData[0]?.shiftApproval);
      setValue(
        "paymentDuePeriodDays",
        responseData[0]?.billingInfo?.paymentDuePeriodDays
      );
      setValue("hrEmail", responseData[0]?.billingInfo?.billingEmails?.hr);
      setValue(
        "financeEmail",
        responseData[0]?.billingInfo?.billingEmails?.finance
      );
      const otherEmails = responseData[0]?.billingInfo?.billingEmails?.others;
      setValue(
        "otherEmail",
        Array.isArray(otherEmails) ? otherEmails.join(", ") : otherEmails || ""
      );
      setValue(
        "otherEmailArray",
        Array.isArray(otherEmails)
          ? otherEmails
          : otherEmails
          ? [otherEmails]
          : []
      );
      setValue(
        "billingName",
        responseData[0]?.billingInfo?.gstDetails?.billingName
      );
      setValue(
        "completeBillingAddress",
        responseData[0]?.billingInfo?.gstDetails?.billingAddress
      );
      setValue(
        "billingCity",
        responseData[0]?.billingInfo?.gstDetails?.billingCity
      );
      setValue(
        "billingState",
        responseData[0]?.billingInfo?.gstDetails?.billingState
      );
      setValue(
        "billingPinCode",
        responseData[0]?.billingInfo?.gstDetails?.billingPinCode
      );
      setValue(
        "billingCountry",
        responseData[0]?.billingInfo?.gstDetails?.billingCountry
      );
      setValue(
        "gstNumber",
        responseData[0]?.billingInfo?.gstDetails?.gstNumber
      );
      setValue(
        "gstCertificate",
        responseData[0]?.billingInfo?.gstDetails?.gstCertificate
      );

      // Set contact fields
      setValue(
        "hrContact",
        responseData[0]?.billingInfo?.contactPhones?.hr || ""
      );
      setValue(
        "financeContact",
        responseData[0]?.billingInfo?.contactPhones?.finance || ""
      );
      // Initialize uploaded files state with existing URLs
      const initialFiles = {
        gst: responseData[0]?.billingInfo?.gstDetails?.gstCertificate?.fileUrl
          ? {
              name: "gst_certificate.pdf",
              url: responseData[0]?.billingInfo?.gstDetails?.gstCertificate
                ?.fileUrl,
              size: "0 KB",
              type: "application/pdf",
            }
          : null,
        pan: responseData[0]?.billingInfo?.gstDetails?.panCertificate?.fileUrl
          ? {
              name: "pan_card.pdf",
              url: responseData[0]?.billingInfo?.gstDetails?.panCertificate
                ?.fileUrl,
              size: "0 KB",
              type: "application/pdf",
            }
          : null,
        tan: responseData[0]?.billingInfo?.gstDetails?.tanCertificate?.fileUrl
          ? {
              name: "tan_document.pdf",
              url: responseData[0]?.billingInfo?.gstDetails?.tanCertificate
                ?.fileUrl,
              size: "0 KB",
              type: "application/pdf",
            }
          : null,
        cancelCheque: responseData[0]?.billingInfo?.bankDetails?.cancelledCheque
          ?.fileUrl
          ? {
              name: "cancel_cheque.pdf",
              url: responseData[0]?.billingInfo?.bankDetails?.cancelledCheque
                ?.fileUrl,
              size: "0 KB",
              type: "application/pdf",
            }
          : null,
        contract: responseData[0]?.billingInfo?.contractDetails?.[0]
          ?.contractCopy?.fileUrl
          ? {
              name: "contract_copy.pdf",
              url: responseData[0]?.billingInfo?.contractDetails?.[0]
                ?.contractCopy?.fileUrl,
              size: "0 KB",
              type: "application/pdf",
            }
          : null,

        decleration: responseData[0]?.billingInfo?.gstDetails?.declarationData
          ?.fileUrl
          ? {
              name: "declaration_document.pdf",
              url: responseData[0]?.billingInfo?.gstDetails?.declarationData
                ?.fileUrl,
              size: "0 KB",
              type: "application/pdf",
            }
          : null,
      };

      setUploadedFiles(initialFiles);

      // Set form values for file URLs
      setValue(
        "gstCertificateUrl",
        responseData[0]?.billingInfo?.gstDetails?.gstCertificate?.fileUrl || ""
      );
      setValue(
        "panCertificateUrl",
        responseData[0]?.billingInfo?.gstDetails?.panCertificate?.fileUrl || ""
      );
      setValue(
        "tanCertificateUrl",
        responseData[0]?.billingInfo?.gstDetails?.tanCertificate?.fileUrl || ""
      );
      setValue(
        "cancelledChequeUrl",
        responseData[0]?.billingInfo?.bankDetails?.cancelledCheque?.fileUrl ||
          ""
      );
      setValue(
        "declerationUrl",
        responseData[0]?.billingInfo?.gstDetails?.declarationData?.fileUrl || ""
      );

      // Handle contract details
      const contractDetails = responseData[0]?.billingInfo?.contractDetails;
      if (contractDetails && contractDetails.length > 0) {
        // Clear existing contract fields
        contractFields.forEach((_, index) => {
          removeContract(index);
        });

        // Add contract details from API
        contractDetails.forEach((contract, index) => {
          if (index === 0) {
            // Update first contract
            setValue(
              `contractDetails.${index}.contractStartDate`,
              contract?.contractStartDate || new Date().toISOString()
            );
            setValue(
              `contractDetails.${index}.contractEndDate`,
              contract?.contractEndDate || new Date().toISOString()
            );
            setValue(
              `contractDetails.${index}.contractCopy.fileUrl`,
              contract?.contractCopy?.fileUrl || ""
            );
            setValue(
              `contractDetails.${index}.isActive`,
              contract?.isActive || false
            );

            // Update uploaded files state
            if (contract?.contractCopy?.fileUrl) {
              setUploadedFiles((prev) => ({
                ...prev,
                [`contract_${index}`]: {
                  name: "contract_copy.pdf",
                  url: contract?.contractCopy?.fileUrl,
                  size: "0 KB",
                  type: "application/pdf",
                  isActive: contract?.isActive || false,
                },
              }));
            }
          } else {
            // Add additional contracts
            appendContract({
              contractStartDate:
                contract?.contractStartDate || new Date().toISOString(),
              contractEndDate:
                contract?.contractEndDate || new Date().toISOString(),
              contractCopy: { fileUrl: contract?.contractCopy?.fileUrl || "" },
              isActive: contract?.isActive || false,
            });

            // Update uploaded files state for additional contracts
            if (contract?.contractCopy?.fileUrl) {
              setUploadedFiles((prev) => ({
                ...prev,
                [`contract_${index}`]: {
                  name: "contract_copy.pdf",
                  url: contract?.contractCopy?.fileUrl,
                  size: "0 KB",
                  type: "application/pdf",
                },
              }));
            }
          }
        });
      }

      // Handle other contacts (array to comma-separated string for display)
      const otherContacts = responseData[0]?.billingInfo?.contactPhones?.others;
      setValue(
        "otherPhone",
        Array.isArray(otherContacts)
          ? otherContacts.join(", ")
          : otherContacts || ""
      );
      setValue(
        "otherPhoneArray",
        Array.isArray(otherContacts)
          ? otherContacts
          : otherContacts
          ? [otherContacts]
          : []
      );
      setValue(
        "isGstRegistered",
        responseData[0]?.billingInfo?.gstDetails?.isGstRegistered
      );
      setValue(
        "panNumber",
        responseData[0]?.billingInfo?.gstDetails?.panNumber
      );
      setValue(
        "tanNumber",
        responseData[0]?.billingInfo?.gstDetails?.tanNumber
      );
      setValue("bankName", responseData[0]?.billingInfo?.bankDetails?.bankName);
      setValue(
        "accountHolderName",
        responseData[0]?.billingInfo?.bankDetails?.accountHolderName
      );
      setValue(
        "accountNumber",
        responseData[0]?.billingInfo?.bankDetails?.accountNumber
      );
      setValue("ifscCode", responseData[0]?.billingInfo?.bankDetails?.ifscCode);
      setValue(
        "branchName",
        responseData[0]?.billingInfo?.bankDetails?.branchName
      );
      setValue("isBillingEntity", responseData[0]?.isBillingEntity);
      setValue("latePaymentFeePercent", responseData[0]?.latePaymentFeePercent);
      setValue("platformFeePercent", responseData[0]?.platformFeePercent);
      setValue(
        "isOneTimeFee",
        responseData[0]?.additionalFeesAndDiscounts?.isOneTimeFee
      );
      setValue(
        "oneTimeFeeAmount",
        responseData[0]?.additionalFeesAndDiscounts?.oneTimeFeeAmount
      );
      setValue(
        "discountCoupon",
        responseData[0]?.additionalFeesAndDiscounts?.discountCoupon
      );
      setValue("branchActivated", responseData[0]?.branchActivated);
      setValue("branchInactive", responseData[0]?.branchInactive);
      setisOneTimeFee(
        responseData[0]?.additionalFeesAndDiscounts?.isOneTimeFee
      );
      // setBranchInActivated(responseData[0]?.branchInactive);
      setBranchActivated(responseData[0]?.branchActivated);
    }
  }, [responseData, setValue]);

  function TabPanel({ children, value, index, ...other }) {
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`branch-tabpanel-${index}`}
        aria-labelledby={`branch-tab-${index}`}
        {...other}
      >
        {value === index && <Box sx={{ py: 2 }}>{children}</Box>}
      </div>
    );
  }

  const indianStates = [
    { key: "Andhra Pradesh", value: "Andhra Pradesh" },
    { key: "Arunachal Pradesh", value: "Arunachal Pradesh" },
    { key: "Assam", value: "Assam" },
    { key: "Bihar", value: "Bihar" },
    { key: "Chhattisgarh", value: "Chhattisgarh" },
    { key: "Goa", value: "Goa" },
    { key: "Gujarat", value: "Gujarat" },
    { key: "Haryana", value: "Haryana" },
    { key: "Himachal Pradesh", value: "Himachal Pradesh" },
    { key: "Jharkhand", value: "Jharkhand" },
    { key: "Jammu and Kashmir", value: "Jammu and Kashmir" },
    { key: "Karnataka", value: "Karnataka" },
    { key: "Kerala", value: "Kerala" },
    { key: "Ladakh", value: "Ladakh" },
    { key: "Madhya Pradesh", value: "Madhya Pradesh" },
    { key: "Maharashtra", value: "Maharashtra" },
    { key: "Manipur", value: "Manipur" },
    { key: "Meghalaya", value: "Meghalaya" },
    { key: "Mizoram", value: "Mizoram" },
    { key: "Nagaland", value: "Nagaland" },
    { key: "Odisha", value: "Odisha" },
    { key: "Punjab", value: "Punjab" },
    { key: "Rajasthan", value: "Rajasthan" },
    { key: "Sikkim", value: "Sikkim" },
    { key: "Tamil Nadu", value: "Tamil Nadu" },
    { key: "Telangana", value: "Telangana" },
    { key: "Tripura", value: "Tripura" },
    { key: "Uttar Pradesh", value: "Uttar Pradesh" },
    { key: "Uttarakhand", value: "Uttarakhand" },
    { key: "West Bengal", value: "West Bengal" },
    {
      key: "Andaman and Nicobar Islands",
      value: "Andaman and Nicobar Islands",
    },
    { key: "Chandigarh", value: "Chandigarh" },
    {
      key: "Dadra and Nagar Haveli and Daman and Diu",
      value: "Dadra and Nagar Haveli and Daman and Diu",
    },
    { key: "Delhi", value: "Delhi" },
    { key: "Lakshadweep", value: "Lakshadweep" },
    { key: "Puducherry", value: "Puducherry" },
  ];

  const stateCodes = {
    "Jammu and Kashmir": "01",
    "Himachal Pradesh": "02",
    Punjab: "03",
    Chandigarh: "04",
    Uttarakhand: "05",
    Haryana: "06",
    Delhi: "07",
    Rajasthan: "08",
    "Uttar Pradesh": "09",
    Bihar: "10",
    Sikkim: "11",
    "Arunachal Pradesh": "12",
    Nagaland: "13",
    Manipur: "14",
    Mizoram: "15",
    Tripura: "16",
    Meghalaya: "17",
    Assam: "18",
    "West Bengal": "19",
    Jharkhand: "20",
    Odisha: "21",
    Chhattisgarh: "22",
    "Madhya Pradesh": "23",
    Gujarat: "24",
    "Dadra and Nagar Haveli and Daman and Diu": "26",
    Maharashtra: "27",
    "Andhra Pradesh": "37",
    Karnataka: "29",
    Goa: "30",
    Lakshadweep: "31",
    Kerala: "32",
    "Tamil Nadu": "33",
    Puducherry: "34",
    "Andaman and Nicobar Islands": "35",
    Telangana: "36",
    Ladakh: "38",
  };

  return (
    <>
      <DashboardLayout>
        <DashboardNavbar />
        {formValues._id ? (
          <MDBox margin={2}>
            <Grid item xs={12}>
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <Link onClick={handleBack}>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      cursor: "pointer",
                    }}
                  >
                    <ArrowBackIos fontSize="small" />
                    back
                  </div>
                </Link>
                {branchActivated ? (
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      flexDirection: "row",
                    }}
                  >
                    <Typography variant="body2" sx={{ ml: 1 }}>
                      Branch:{" "}
                    </Typography>
                    <CheckCircleIcon sx={{ ml: 1 }} color="success" />
                    <Typography variant="body2" color="#4caf50" sx={{ ml: 1 }}>
                      Active
                    </Typography>
                  </div>
                ) : (
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      flexDirection: "row",
                    }}
                  >
                    <Typography variant="body2" sx={{ ml: 1 }}>
                      Branch:{" "}
                    </Typography>
                    <Typography variant="body2" color="red" sx={{ ml: 1 }}>
                      Inactive
                    </Typography>
                  </div>
                )}
              </div>
            </Grid>
            {/* <Divider /> */}
            <Box sx={{ borderBottom: 1, borderColor: "divider", mb: 2 }}>
              <Tabs
                value={tabValue}
                onChange={handleTabChange}
                aria-label="branch tabs"
                textColor="primary"
                indicatorColor="primary"
              >
                <Tab label="Branch Information" />
                <Tab label="Billing Details" />
              </Tabs>
            </Box>

            <DialogContent>
              <form onSubmit={handleSubmit(onSubmit)}>
                {branchData?.length > 0 &&
                  branchData?.map((elem) => {
                    return (
                      <>
                        <div key={elem._id}>
                          <Grid item xs={8} position="relative">
                            <MDInput
                              onKeyDown={(e) => {
                                e.key === "Enter" && e.preventDefault();
                              }}
                              placeholder=""
                              sx={{ width: "100%", marginTop: "0.4rem" }}
                              inputProps={{
                                style: { fontSize: 15, fontWeight: "bold" },
                              }}
                              // {...register("name")}
                              {...register("jobLocation.branchName")}
                              // value={elem?.jobLocation?.branchName}
                            />
                          </Grid>

                          <Grid item xs={12}>
                            <Typography variant="body">
                              ID:{elem?._id}
                            </Typography>
                          </Grid>
                          <TabPanel value={tabValue} index={0}>
                            <Grid container spacing={3}>
                              {/* Name Title */}

                              {/* <Grid item xs={8}>
                            <MDInput
                             onKeyDown={(e) => { e.key === 'Enter' && e.preventDefault() }}
                              placeholder=""
                              sx={{ width: "100%", marginTop: "0.4rem" }}
                              inputProps={{
                                style: { fontSize: 15, fontWeight: "bold" },
                              }}
                              // {...register("name")}
                              {...register("jobLocation.branchName")}
                              // value={elem?.jobLocation?.branchName}
                            />
                          </Grid>

                          <Grid item xs={12}>
                            <Typography variant="body">
                              ID:{elem?._id}
                            </Typography>
                          </Grid> */}

                              {/* is Deleted */}
                              <Grid item xs={12} md={12}>
                                <Grid item xs={2}>
                                  <FormGroup>
                                    <FormControlLabel
                                      control={
                                        <Controller
                                          defaultValue={false}
                                          name="isDeleted"
                                          control={control}
                                          render={({ field: props }) => (
                                            <Checkbox
                                              {...props}
                                              checked={props.value}
                                              onChange={(e) =>
                                                props.onChange(e.target.checked)
                                              }
                                            />
                                          )}
                                        />
                                      }
                                      label="Is Deleted"
                                    />
                                  </FormGroup>
                                </Grid>
                              </Grid>

                              {/* company */}
                              {/* CreatedBy */}
                              <Grid item xs={4}>
                                <Typography
                                  variant="subtitle1"
                                  sx={{ width: "80%", marginTop: "0.8rem" }}
                                >
                                  Company
                                </Typography>
                              </Grid>
                              <Grid item xs={8}>
                                <SelectDropDownNew
                                  options={organizationOptions}
                                  getValues={getValues}
                                  placeholder="Organization"
                                  control={control}
                                  name="organization.name"
                                  defaultValue="none"
                                  customOnChange={handleOrganizationChange}
                                />
                              </Grid>

                              {/* Corporate */}
                              <Grid item xs={4}>
                                <Typography
                                  variant="subtitle1"
                                  sx={{ width: "80%", marginTop: "0.8rem" }}
                                >
                                  Corporate
                                </Typography>
                              </Grid>
                              <Grid item xs={8}>
                                <SelectDropDownNew
                                  options={companyOptions}
                                  getValues={getValues}
                                  placeholder="Company"
                                  control={control}
                                  name="company.name"
                                  defaultValue="none"
                                  customOnChange={handleCompanyChange}
                                />
                              </Grid>

                              {/*Brand */}
                              {/* <Grid item xs={4}>
                            <Typography
                              variant="subtitle1"
                              sx={{ width: "80%", marginTop: "0.8rem" }}
                            >
                              Brand
                            </Typography>
                          </Grid>
                          <Grid item xs={8}>
                            <MDInput
                             onKeyDown={(e) => { e.key === 'Enter' && e.preventDefault() }}
                              placeholder=""
                              sx={{ width: "100%", marginTop: "0.4rem" }}
                              inputProps={{
                                style: { fontSize: 15, fontWeight: "bold" },
                              }}
                              {...register("brand")}
                            />
                          </Grid> */}

                              {/* Sub Brand */}

                              {/* <Grid item xs={4}>
                            <Typography
                              variant="subtitle1"
                              sx={{ width: "80%", marginTop: "0.8rem" }}
                            >
                              Sub Brand
                            </Typography>
                          </Grid>
                          <Grid item xs={8}>
                            <MDInput
                             onKeyDown={(e) => { e.key === 'Enter' && e.preventDefault() }}
                              placeholder=""
                              sx={{ width: "100%", marginTop: "0.4rem" }}
                              inputProps={{
                                style: { fontSize: 15, fontWeight: "bold" },
                              }}
                              {...register("subBrand")}
                            />
                          </Grid> */}

                              {/* Contact Details */}
                              <Grid item xs={12}>
                                <Paper sx={{ padding: "1rem" }}>
                                  <Typography
                                    variant="subtitle1"
                                    style={{ fontWeight: 500 }}
                                  >
                                    Contact Details
                                  </Typography>
                                  <ul style={{ listStyleType: "none" }}>
                                    {contactField.map((field, index) => (
                                      <li>
                                        <Grid container spacing={2}>
                                          <Grid item xs={3}>
                                            <Typography variant="subtitle1">
                                              Address Address
                                            </Typography>
                                          </Grid>
                                          <Grid item xs={9}>
                                            <MDInput
                                              onKeyDown={(e) => {
                                                e.key === "Enter" &&
                                                  e.preventDefault();
                                              }}
                                              placeholder=""
                                              sx={{
                                                width: "100%",
                                                marginTop: "0.4rem",
                                              }}
                                              inputProps={{
                                                style: {
                                                  fontSize: 15,
                                                  fontWeight: "bold",
                                                },
                                              }}
                                              {...register(
                                                `contactDetails.[${index}].address.address`,
                                              )}
                                            />
                                          </Grid>

                                          <Grid item xs={3}>
                                            <Typography variant="subtitle1">
                                              Address City
                                            </Typography>
                                          </Grid>
                                          <Grid item xs={9}>
                                            <MDInput
                                              onKeyDown={(e) => {
                                                e.key === "Enter" &&
                                                  e.preventDefault();
                                              }}
                                              placeholder=""
                                              sx={{
                                                width: "100%",
                                                marginTop: "0.4rem",
                                              }}
                                              inputProps={{
                                                style: {
                                                  fontSize: 15,
                                                  fontWeight: "bold",
                                                },
                                              }}
                                              {...register(
                                                `contactDetails.[${index}].address.city`,
                                              )}
                                            />
                                          </Grid>

                                          <Grid item xs={3}>
                                            <Typography variant="subtitle1">
                                              Address State
                                            </Typography>
                                          </Grid>
                                          <Grid item xs={9}>
                                            <MDInput
                                              onKeyDown={(e) => {
                                                e.key === "Enter" &&
                                                  e.preventDefault();
                                              }}
                                              placeholder=""
                                              sx={{
                                                width: "100%",
                                                marginTop: "0.4rem",
                                              }}
                                              inputProps={{
                                                style: {
                                                  fontSize: 15,
                                                  fontWeight: "bold",
                                                },
                                              }}
                                              {...register(
                                                `contactDetails.[${index}].address.state`,
                                              )}
                                            />
                                          </Grid>

                                          <Grid item xs={3}>
                                            <Typography variant="subtitle1">
                                              Address Pin
                                            </Typography>
                                          </Grid>
                                          <Grid item xs={9}>
                                            <MDInput
                                              onKeyDown={(e) => {
                                                e.key === "Enter" &&
                                                  e.preventDefault();
                                              }}
                                              placeholder=""
                                              sx={{
                                                width: "100%",
                                                marginTop: "0.4rem",
                                              }}
                                              inputProps={{
                                                style: {
                                                  fontSize: 15,
                                                  fontWeight: "bold",
                                                },
                                              }}
                                              {...register(
                                                `contactDetails.[${index}].address.pin`,
                                              )}
                                            />
                                          </Grid>

                                          <Grid item xs={3}>
                                            <Typography variant="subtitle1">
                                              Address Country
                                            </Typography>
                                          </Grid>
                                          <Grid item xs={9}>
                                            <MDInput
                                              onKeyDown={(e) => {
                                                e.key === "Enter" &&
                                                  e.preventDefault();
                                              }}
                                              placeholder=""
                                              sx={{
                                                width: "100%",
                                                marginTop: "0.4rem",
                                              }}
                                              inputProps={{
                                                style: {
                                                  fontSize: 15,
                                                  fontWeight: "bold",
                                                },
                                              }}
                                              {...register(
                                                `contactDetails.[${index}].address.country`,
                                              )}
                                            />
                                          </Grid>

                                          <Grid item xs={3}>
                                            <Typography variant="subtitle1">
                                              Address Coords
                                            </Typography>
                                          </Grid>
                                          <Grid item xs={9}>
                                            <NestedArray
                                              nestIndex={index}
                                              {...{ control, register }}
                                            />
                                          </Grid>
                                          <Grid item xs={3}>
                                            <Typography variant="subtitle1">
                                              Email
                                            </Typography>
                                          </Grid>
                                          <Grid item xs={9}>
                                            <MDInput
                                              onKeyDown={(e) => {
                                                e.key === "Enter" &&
                                                  e.preventDefault();
                                              }}
                                              placeholder=""
                                              sx={{
                                                width: "100%",
                                                marginTop: "0.4rem",
                                              }}
                                              inputProps={{
                                                style: {
                                                  fontSize: 15,
                                                  fontWeight: "bold",
                                                },
                                              }}
                                              {...register(
                                                `contactDetails.${index}.email`,
                                              )}
                                            />
                                          </Grid>

                                          <Grid item xs={3}>
                                            <Typography variant="subtitle1">
                                              Phone
                                            </Typography>
                                          </Grid>
                                          <Grid item xs={9}>
                                            <MDInput
                                              onKeyDown={(e) => {
                                                e.key === "Enter" &&
                                                  e.preventDefault();
                                              }}
                                              placeholder=""
                                              sx={{
                                                width: "100%",
                                                marginTop: "0.4rem",
                                              }}
                                              inputProps={{
                                                style: {
                                                  fontSize: 15,
                                                  fontWeight: "bold",
                                                },
                                              }}
                                              {...register(
                                                `contactDetails.[${index}].phone`,
                                              )}
                                            />
                                          </Grid>

                                          <Grid item xs={3}>
                                            <Typography variant="subtitle1">
                                              Contact Days
                                            </Typography>
                                          </Grid>
                                          <Grid item xs={9}>
                                            <MultiSelectDropdown
                                              options={days}
                                              name={`contactDetails.[${index}].contactDays`}
                                              getValues={getValues}
                                              setValue={setValue}
                                              control={control}
                                              customOnChange={(e) => {
                                                setValue(
                                                  `contactDetails.[${index}].contactDays`,
                                                  e,
                                                );
                                              }}
                                            />
                                            {/* <Select
                                          {...register(
                                            `contactDetails.[${index}].contactDays.[${index}]`
                                          )}
                                          defaultValue={`contactDetails.[${index}].contactDays.[${index}]`}
                                          labelId="mutiple-select-label1"
                                          multiple
                                          value={selectedDays}
                                          onChange={(event, index) =>
                                            handleChangeDays(event, index)
                                          }
                                          renderValue={(selectedDays) =>
                                            selectedDays.join(", ")
                                          }
                                          MenuProps={MenuProps}
                                          sx={{
                                            height: "3rem",
                                            width: "37rem",
                                          }}
                                        >
                                          {days.map((option) => (
                                            <MenuItem
                                              key={option}
                                              value={option}
                                            >
                                              <ListItemIcon>
                                                <Checkbox
                                                  checked={
                                                    selectedDays.indexOf(
                                                      option
                                                    ) > -1
                                                  }
                                                />
                                              </ListItemIcon>
                                              <ListItemText primary={option} />
                                            </MenuItem>
                                          ))}
                                        </Select> */}
                                          </Grid>

                                          <Grid item xs={3}>
                                            <Typography variant="subtitle1">
                                              Contact Start DateTime
                                            </Typography>
                                          </Grid>

                                          <Grid item xs={9}>
                                            {adStartDateChange ? (
                                              <Controller
                                                name={`contactDetails.[${index}].contactTimeStart`}
                                                control={control}
                                                render={({ field }) => (
                                                  <LocalizationProvider
                                                    dateAdapter={AdapterDayjs}
                                                  >
                                                    <DatePicker
                                                      defaultValue={null}
                                                      // minDate={today}
                                                      {...field}
                                                      inputFormat="DD/MM/YYYY"
                                                      // value={adStartDate}
                                                      {...register(
                                                        `contactDetails.[${index}].contactTimeStart`,
                                                      )}
                                                      onChange={(newValue) => {
                                                        setDate(newValue?.$d);

                                                        setAdStartDate(
                                                          newValue,
                                                        );
                                                        setValue(
                                                          `contactDetails.[${index}].contactTimeStart`,
                                                          Moment(
                                                            newValue?.$d,
                                                          ).format(
                                                            "YYYY-MM-DDTHH:mm:ss[Z]",
                                                          ),
                                                        );
                                                        setValue(
                                                          `contactDetails.[${index}].contactTimeEnd`,
                                                          null,
                                                        );
                                                      }}
                                                      renderInput={(params) => (
                                                        <TextField
                                                          {...params}
                                                        />
                                                      )}
                                                    />
                                                  </LocalizationProvider>
                                                )}
                                              />
                                            ) : (
                                              <>
                                                <MDInput
                                                  value={startDate[index]}
                                                  disabled
                                                />

                                                <IconButton
                                                  onClick={() => {
                                                    setAdStartDateChange(true);
                                                  }}
                                                >
                                                  <Edit />
                                                </IconButton>
                                              </>
                                            )}
                                          </Grid>

                                          <Grid item xs={3}>
                                            <Typography variant="subtitle1">
                                              Contact End DateTime
                                            </Typography>
                                          </Grid>

                                          <Grid item xs={9}>
                                            {adEndDateChange ? (
                                              <Controller
                                                name={`contactDetails.[${index}].contactTimeEnd`}
                                                control={control}
                                                render={({ field }) => (
                                                  <LocalizationProvider
                                                    dateAdapter={AdapterDayjs}
                                                  >
                                                    <DatePicker
                                                      defaultValue={null}
                                                      minDate={getValues(
                                                        `contactDetails.[${index}].contactTimeStart`,
                                                      )}
                                                      {...register(
                                                        `contactDetails.[${index}].contactTimeEnd`,
                                                      )}
                                                      {...field}
                                                      inputFormat="DD/MM/YYYY"
                                                      // value={adEndDate}
                                                      onChange={(newValue) => {
                                                        setAdEndDate(newValue);
                                                        setValue(
                                                          `contactDetails.[${index}].contactTimeEnd`,
                                                          Moment(
                                                            newValue?.$d,
                                                          ).format(
                                                            "YYYY-MM-DDTHH:mm:ss[Z]",
                                                          ),
                                                        );
                                                      }}
                                                      renderInput={(params) => (
                                                        <TextField
                                                          {...params}
                                                        />
                                                      )}
                                                    />
                                                  </LocalizationProvider>
                                                )}
                                              />
                                            ) : (
                                              <>
                                                <MDInput
                                                  value={datee2}
                                                  disabled
                                                />

                                                <IconButton
                                                  onClick={() => {
                                                    setAdEndDateChange(true);
                                                  }}
                                                >
                                                  <Edit />
                                                </IconButton>
                                              </>
                                            )}
                                          </Grid>
                                        </Grid>

                                        <MDBox sx={{ textAlign: "right" }}>
                                          <MDButton
                                            variant="contained"
                                            onClick={(e) => {
                                              e.preventDefault();
                                              contactRemove(index);
                                            }}
                                          >
                                            <Typography
                                              color="error"
                                              variant="body"
                                            >
                                              Remove
                                            </Typography>
                                          </MDButton>
                                        </MDBox>
                                        {/* </MDBox>  */}
                                      </li>
                                    ))}
                                    <MDButton
                                      variant="contained"
                                      color="info"
                                      onClick={(e) => {
                                        e.preventDefault();
                                        contactAppend({});
                                      }}
                                    >
                                      + Add
                                    </MDButton>
                                  </ul>
                                </Paper>
                              </Grid>

                              {/* checkbox */}
                              {/* <Grid item xs={12} md={12}>
                            <FormGroup>
                              <FormControlLabel
                                control={
                                  <Controller
                                    defaultValue={false}
                                    name="isBillingEntity"
                                    control={control}
                                    render={({ field: props }) => (
                                      <Checkbox
                                        {...props}
                                        checked={props.value}
                                        {...register("isBillingEntity")}
                                        onChange={(e) =>
                                          props.onChange(e.target.checked)
                                        }
                                      />
                                    )}
                                  />
                                }
                                label="is Billing Entity?"
                              />
                            </FormGroup>
                          </Grid> */}

                              {/* Billing Address Address Address */}
                              {/* <Grid item xs={4}>
                            <Typography
                              variant="subtitle1"
                              sx={{ width: "80%", marginTop: "0.8rem" }}
                            >
                              Billing Address Address Address
                            </Typography>
                          </Grid>
                          <Grid item xs={8}>
                            <MDInput
                             onKeyDown={(e) => { e.key === 'Enter' && e.preventDefault() }}
                              placeholder=""
                              sx={{ width: "100%", marginTop: "0.4rem" }}
                              inputProps={{
                                style: { fontSize: 15, fontWeight: "bold" },
                              }}
                              {...register(`billingAddress.address.address`)}
                            />
                          </Grid> */}

                              {/* Billing Address Address City */}
                              {/* <Grid item xs={4}>
                            <Typography
                              variant="subtitle1"
                              sx={{ width: "80%", marginTop: "0.8rem" }}
                            >
                              Billing Address Address City
                            </Typography>
                          </Grid>
                          <Grid item xs={8}>
                            <MDInput
                             onKeyDown={(e) => { e.key === 'Enter' && e.preventDefault() }}
                              placeholder=""
                              sx={{ width: "100%", marginTop: "0.4rem" }}
                              inputProps={{
                                style: { fontSize: 15, fontWeight: "bold" },
                              }}
                              {...register(`billingAddress.address.city`)}
                            />
                          </Grid> */}

                              {/* Billing Address Address state */}
                              {/* <Grid item xs={4}>
                            <Typography
                              variant="subtitle1"
                              sx={{ width: "80%", marginTop: "0.8rem" }}
                            >
                              Billing Address Address State
                            </Typography>
                          </Grid>
                          <Grid item xs={8}>
                            <MDInput
                             onKeyDown={(e) => { e.key === 'Enter' && e.preventDefault() }}
                              placeholder=""
                              sx={{ width: "100%", marginTop: "0.4rem" }}
                              inputProps={{
                                style: { fontSize: 15, fontWeight: "bold" },
                              }}
                              {...register(`billingAddress.address.state`)}
                            />
                          </Grid> */}

                              {/* Billing Address Address pin */}
                              {/* <Grid item xs={4}>
                            <Typography
                              variant="subtitle1"
                              sx={{ width: "80%", marginTop: "0.8rem" }}
                            >
                              Billing Address Address Pin
                            </Typography>
                          </Grid>
                          <Grid item xs={8}>
                            <MDInput
                             onKeyDown={(e) => { e.key === 'Enter' && e.preventDefault() }}
                              placeholder=""
                              sx={{ width: "100%", marginTop: "0.4rem" }}
                              inputProps={{
                                style: { fontSize: 15, fontWeight: "bold" },
                              }}
                              {...register(`billingAddress.address.pin`)}
                            />
                          </Grid> */}

                              {/* Billing Address Address Country */}
                              {/* <Grid item xs={4}>
                            <Typography
                              variant="subtitle1"
                              sx={{ width: "80%", marginTop: "0.8rem" }}
                            >
                              Billing Address Address Country
                            </Typography>
                          </Grid>
                          <Grid item xs={8}>
                            <MDInput
                             onKeyDown={(e) => { e.key === 'Enter' && e.preventDefault() }}
                              placeholder=""
                              sx={{ width: "100%", marginTop: "0.4rem" }}
                              inputProps={{
                                style: { fontSize: 15, fontWeight: "bold" },
                              }}
                              {...register(`billingAddress.address.country`)}
                            />
                          </Grid> */}

                              {/* Billing Address Address Coords */}
                              {/* <Grid item xs={4}>
                            <Typography
                              variant="subtitle1"
                              sx={{ width: "80%", marginTop: "0.8rem" }}
                            >
                              Billing Address Address Coords
                            </Typography>
                          </Grid> */}
                              {/* <Grid item xs={8}>
                            <ul style={{ listStyleType: "none" }}>
                              {coordField.map((field, index) => (
                                <li>
                                  <Grid container spacing={2}>
                                    <MDInput
                                     onKeyDown={(e) => { e.key === 'Enter' && e.preventDefault() }}
                                      type="number"
                                      placeholder=""
                                      sx={{
                                        width: "100%",
                                        marginTop: "0.4rem",
                                      }}
                                      inputProps={{
                                        style: {
                                          fontSize: 15,
                                          fontWeight: "bold",
                                        },
                                      }}
                                      {...register(
                                        `billingAddress.address.coords[${index}]`
                                      )}
                                    />
                                  </Grid>

                                  <MDBox
                                    sx={{
                                      textAlign: "right",
                                      background: "transparent",
                                    }}
                                  >
                                    <MDButton
                                      variant="outlined"
                                      sx={{
                                        border: "none",
                                        height: "10px",
                                        width: "30px",
                                      }}
                                      onMouseHover={{ color: "black" }}
                                      onClick={(e) => {
                                        e.preventDefault();
                                        coordRemove(index);
                                      }}
                                    >
                                      <Typography
                                        color="error"
                                        sx={{ fontSize: "12px" }}
                                        onHover={{ color: "black" }}
                                      >
                                        Remove
                                      </Typography>
                                    </MDButton>
                                  </MDBox>
                                </li>
                              ))}
                              <MDButton
                                variant="contained"
                                color="info"
                                onClick={(e) => {
                                  e.preventDefault();
                                  coordAppend({});
                                }}
                              >
                                + Add
                              </MDButton>
                            </ul>
                          </Grid> */}

                              {/* Billing Address gst number */}
                              {/* <Grid item xs={4}>
                            <Typography
                              variant="subtitle1"
                              sx={{ width: "80%", marginTop: "0.8rem" }}
                            >
                              Billing Address GST Number
                            </Typography>
                          </Grid>
                          <Grid item xs={8}>
                            <MDInput
                             onKeyDown={(e) => { e.key === 'Enter' && e.preventDefault() }}
                              placeholder=""
                              sx={{ width: "100%", marginTop: "0.4rem" }}
                              inputProps={{
                                style: { fontSize: 15, fontWeight: "bold" },
                              }}
                              {...register(`billingAddress.gstNumber`)}
                            />
                          </Grid> */}

                              {/* Billing Address is GST registered */}
                              {/* <Grid item xs={12} md={12}>
                            <FormGroup>
                              <FormControlLabel
                                control={
                                  <Controller
                                    defaultValue={false}
                                    name="billingAddress.isGstRegistered"
                                    control={control}
                                    render={({ field: props }) => (
                                      <Checkbox
                                        {...props}
                                        checked={props.value}
                                        onChange={(e) =>
                                          props.onChange(e.target.checked)
                                        }
                                      />
                                    )}
                                  />
                                }
                                label="Billing Address is GST Registered?"
                              />
                            </FormGroup>
                          </Grid> */}

                              {/* Documents */}
                              {/* <Grid item xs={12}>
                            <DynamicDocuments
                              control={control}
                              getValues={getValues}
                              setValue={setValue}
                              register={register}
                              selectOptions={docTypeOptions}
                            /> */}
                              {/* <Paper sx={{ padding: "1rem" }}> */}
                              {/* <Typography
                                variant="subtitle1"
                                style={{ fontWeight: 500 }}
                              >
                                Document
                              </Typography> */}

                              {/* <ul style={{ listStyleType: "none" }}>
                                {docField.map((field, index) => (
                                  <li>
                                    <Grid container spacing={2}>
                                      <Grid item xs={3}>
                                        <Typography variant="subtitle1">
                                          Doc Type
                                        </Typography>
                                      </Grid>
                                      <Grid item xs={9}>
                                        <SelectDropDownNew
                                          control={control}
                                          options={docTypeOptions}
                                          placeholder="Doc Type"
                                          getValues={getValues}
                                          {...register(
                                            `documents.[${index}].docType.name`
                                          )}
                                          name={`documents.[${index}].docType.name`}
                                          customOnChange={(e) => {
                                            docTypeOptions.map((elem) => {
                                              if (
                                                elem.value == e.target.value
                                              ) {
                                                setValue(
                                                  `documents.[${index}].docType`,
                                                  `${elem.key}`
                                                );
                                              }
                                            });
                                          }}
                                        />
                                       
                                      </Grid>

                                      <Grid item xs={3}>
                                        <Typography variant="subtitle1">
                                          Uploaded At
                                        </Typography>
                                      </Grid>
                                      <Grid item xs={9}>
                                        <MDInput
                                          placeholder=""
                                          sx={{
                                            width: "100%",
                                            marginTop: "0.4rem",
                                          }}
                                          inputProps={{
                                            style: {
                                              fontSize: 15,
                                              fontWeight: "bold",
                                            },
                                          }}
                                          {...register(
                                            `documents.[${index}].uploadedAt`
                                          )}
                                        />
                                      </Grid>
                                    </Grid>

                                    <MDBox sx={{ textAlign: "right" }}>
                                      <MDButton
                                        variant="contained"
                                        onClick={(e) => {
                                          e.preventDefault();
                                          docRemove(index);
                                        }}
                                      >
                                        <Typography
                                          color="error"
                                          variant="body"
                                        >
                                          Remove
                                        </Typography>
                                      </MDButton>
                                    </MDBox>
                                    {/* </MDBox>  
                                  </li>
                                ))}
                                <MDButton
                                  variant="contained"
                                  color="info"
                                  onClick={(e) => {
                                  
                                    e.preventDefault();
                                    docAppend({});
                                  }}
                                >
                                  + Add
                                </MDButton>
                              </ul> */}
                              {/* </Paper> */}
                              {/* </Grid> */}

                              {/* Job Location Hospital Name */}
                              <Grid item xs={4}>
                                <Typography
                                  variant="subtitle1"
                                  sx={{ width: "80%", marginTop: "0.8rem" }}
                                >
                                  Job Hospital Name
                                </Typography>
                              </Grid>
                              <Grid item xs={8}>
                                <MDInput
                                  onKeyDown={(e) => {
                                    e.key === "Enter" && e.preventDefault();
                                  }}
                                  placeholder=""
                                  sx={{ width: "100%", marginTop: "0.4rem" }}
                                  inputProps={{
                                    style: { fontSize: 15, fontWeight: "bold" },
                                  }}
                                  {...register("jobLocation.hospitalName")}
                                />
                              </Grid>

                              {/* Job Location Address Address */}
                              <Grid item xs={4}>
                                <Typography
                                  variant="subtitle1"
                                  sx={{ width: "80%", marginTop: "0.8rem" }}
                                >
                                  Job Address
                                  <span style={{ color: "red" }}></span>
                                </Typography>
                              </Grid>
                              <Grid item xs={8}>
                                <MDInput
                                  onKeyDown={(e) => {
                                    e.key === "Enter" && e.preventDefault();
                                  }}
                                  placeholder=""
                                  sx={{ width: "100%", marginTop: "0.4rem" }}
                                  inputProps={{
                                    style: { fontSize: 15, fontWeight: "bold" },
                                  }}
                                  {...register("jobLocation.address.address", {
                                    // required: "Job Address is required",
                                  })}
                                  // error={!!errors?.jobLocation?.address?.address}
                                  // helperText={
                                  //   errors?.jobLocation?.address?.address?.message
                                  // }
                                />
                              </Grid>

                              {/* Job Location Address City */}
                              <Grid item xs={4}>
                                <Typography
                                  variant="subtitle1"
                                  sx={{ width: "80%", marginTop: "0.8rem" }}
                                >
                                  Job City<span style={{ color: "red" }}></span>
                                </Typography>
                              </Grid>
                              <Grid item xs={8}>
                                <SelectDropDownNew
                                  options={cityOptions}
                                  name={`jobLocation.address.city`}
                                  getValues={getValues}
                                  control={control}
                                  defaultValue="none"
                                  setValue={setValue}
                                  placeholder="Select"
                                  customOnChange={(e) => {
                                    setValue(
                                      `jobLocation.address.city`,
                                      e.target.value,
                                    );
                                  }}
                                />
                                {/* <MDInput
                              placeholder=""
                              sx={{ width: "100%", marginTop: "0.4rem" }}
                              inputProps={{
                                style: { fontSize: 15, fontWeight: "bold" },
                              }}
                              {...register("jobLocation.address.city")}
                            /> */}
                              </Grid>

                              {/* Job Location Address State*/}
                              <Grid item xs={4}>
                                <Typography
                                  variant="subtitle1"
                                  sx={{ width: "80%", marginTop: "0.8rem" }}
                                >
                                  Job State
                                  <span style={{ color: "red" }}></span>
                                </Typography>
                              </Grid>
                              <Grid item xs={8}>
                                <MDInput
                                  onKeyDown={(e) => {
                                    e.key === "Enter" && e.preventDefault();
                                  }}
                                  placeholder=""
                                  sx={{ width: "100%", marginTop: "0.4rem" }}
                                  inputProps={{
                                    style: { fontSize: 15, fontWeight: "bold" },
                                  }}
                                  {...register("jobLocation.address.state", {
                                    // required: "Job State is required",
                                  })}
                                  // error={!!errors?.jobLocation?.address?.state}
                                  // helperText={errors?.jobLocation?.address?.state?.message}
                                />
                              </Grid>

                              {/* Job Location Address pin */}
                              <Grid item xs={4}>
                                <Typography
                                  variant="subtitle1"
                                  sx={{ width: "80%", marginTop: "0.8rem" }}
                                >
                                  Job PinCode
                                  <span style={{ color: "red" }}></span>
                                </Typography>
                              </Grid>
                              <Grid item xs={8}>
                                <MDInput
                                  onKeyDown={(e) => {
                                    e.key === "Enter" && e.preventDefault();
                                  }}
                                  placeholder=""
                                  type="number"
                                  sx={{ width: "100%", marginTop: "0.4rem" }}
                                  inputProps={{
                                    style: { fontSize: 15, fontWeight: "bold" },
                                  }}
                                  {...register("jobLocation.address.pin", {
                                    // required: "Job PinCode is required",
                                    pattern: {
                                      value: /^[0-9]{6}$/, // Pincode must be exactly 6 digits
                                      message: "Invalid pincode format",
                                    },
                                    onChange: (e) => {
                                      // Allow only numbers and limit to 6 digits
                                      e.target.value = e.target.value
                                        .replace(/\D/g, "")
                                        .slice(0, 6);
                                    },
                                  })}
                                  // error={!!errors?.jobLocation?.address?.pin}
                                  // helperText={errors?.jobLocation?.address?.pin?.message}
                                />
                              </Grid>
                              {/* Job Location Address Country */}
                              <Grid item xs={4}>
                                <Typography
                                  variant="subtitle1"
                                  sx={{ width: "80%", marginTop: "0.8rem" }}
                                >
                                  Job Country
                                  <span style={{ color: "red" }}></span>
                                </Typography>
                              </Grid>
                              <Grid item xs={8}>
                                <MDInput
                                  onKeyDown={(e) => {
                                    e.key === "Enter" && e.preventDefault();
                                  }}
                                  placeholder=""
                                  sx={{ width: "100%", marginTop: "0.4rem" }}
                                  inputProps={{
                                    style: { fontSize: 15, fontWeight: "bold" },
                                  }}
                                  {...register("jobLocation.address.country", {
                                    // required: "Job Country is required",
                                  })}
                                  // error={!!errors?.jobLocation?.address?.country}
                                  // helperText={errors?.jobLocation?.address?.country?.message}
                                />
                              </Grid>

                              {/* Latitude */}
                              <Grid item xs={4}>
                                <Typography
                                  variant="subtitle1"
                                  sx={{ width: "80%", marginTop: "0.8rem" }}
                                >
                                  Latitude
                                  <span style={{ color: "red" }}>*</span>
                                </Typography>
                              </Grid>
                              <Grid item xs={8}>
                                <MDInput
                                  onKeyDown={(e) => {
                                    e.key === "Enter" && e.preventDefault();
                                  }}
                                  placeholder=""
                                  sx={{ width: "100%", marginTop: "0.4rem" }}
                                  inputProps={{
                                    style: { fontSize: 15, fontWeight: "bold" },
                                  }}
                                  {...register("jobLocation.address.lat")}
                                  // error={errors?.jobLocation?.address?.lat?.message}
                                  // helperText={
                                  //   errors?.jobLocation?.address?.lat?.message
                                  // }
                                />
                              </Grid>

                              {/* Longitude */}
                              <Grid item xs={4}>
                                <Typography
                                  variant="subtitle1"
                                  sx={{ width: "80%", marginTop: "0.8rem" }}
                                >
                                  Longitude
                                  <span style={{ color: "red" }}>*</span>
                                </Typography>
                              </Grid>
                              <Grid item xs={8}>
                                <MDInput
                                  onKeyDown={(e) => {
                                    e.key === "Enter" && e.preventDefault();
                                  }}
                                  placeholder=""
                                  sx={{ width: "100%", marginTop: "0.4rem" }}
                                  inputProps={{
                                    style: { fontSize: 15, fontWeight: "bold" },
                                  }}
                                  {...register("jobLocation.address.long")}
                                  // error={
                                  //   errors?.jobLocation?.address?.long?.message
                                  // }
                                  // helperText={
                                  //   errors?.jobLocation?.address?.long?.message
                                  // }
                                />
                              </Grid>

                              {/* Payment Type */}
                              <Grid item xs={4}>
                                <Typography
                                  variant="subtitle1"
                                  sx={{ width: "80%", marginTop: "0.8rem" }}
                                >
                                  Payment Type
                                  <span style={{ color: "red" }}>*</span>
                                </Typography>
                              </Grid>
                              <Grid item xs={8}>
                                <SelectDropDownNew
                                  control={control}
                                  options={selectedPaymentTypeOption}
                                  getValues={getValues}
                                  name="paymentType"
                                  placeholder="Select"
                                  customOnChange={(e) => {
                                    setValue("paymentType", e.target.value);
                                  }}
                                />
                              </Grid>

                              {/* job approval */}
                              <Grid item xs={12} md={12}>
                                <FormGroup>
                                  <FormControlLabel
                                    control={
                                      <Controller
                                        defaultValue={false}
                                        name="isJobApprovalRequired"
                                        control={control}
                                        render={({ field: props }) => (
                                          <Checkbox
                                            {...props}
                                            checked={props.value}
                                            {...register(
                                              "isJobApprovalRequired",
                                            )}
                                            onChange={(e) =>
                                              props.onChange(e.target.checked)
                                            }
                                          />
                                        )}
                                      />
                                    }
                                    label="Is Job Approval required"
                                  />
                                </FormGroup>
                              </Grid>

                              {/* test required */}
                              <Grid item xs={12} md={12}>
                                <FormGroup>
                                  <FormControlLabel
                                    control={
                                      <Controller
                                        defaultValue={false}
                                        name="isTestRequired"
                                        control={control}
                                        render={({ field: props }) => (
                                          <Checkbox
                                            {...props}
                                            checked={props.value}
                                            {...register("isTestRequired")}
                                            onChange={(e) =>
                                              props.onChange(e.target.checked)
                                            }
                                          />
                                        )}
                                      />
                                    }
                                    label="Is Test Required"
                                  />
                                </FormGroup>
                              </Grid>

                              {/* shifts */}

                              {/* <Grid item xs={12}>
                            <Paper sx={{ padding: "1rem" }}>
                              <Typography
                                variant="subtitle1"
                                style={{ fontWeight: 500 }}
                              >
                                Shifts
                              </Typography>
                              <ul style={{ listStyleType: "none" }}>
                                {shiftField.map((field, index) => (
                                  <li>
                                    <Grid container spacing={2}>
                                      <Grid item xs={3}>
                                        <Typography variant="subtitle1">
                                          Shift Type
                                        </Typography>
                                      </Grid>
                                      <Grid item xs={9}>
                                        <SelectDropDownNew
                                          control={control}
                                          options={shiftOptions}
                                          placeholder="Shift"
                                          getValues={getValues}
                                          {...register(
                                            `shifts.[${index}].shiftType`
                                          )}
                                          customOnChange={(e) =>
                                            setValue(
                                              `shifts.[${index}].shiftType`,
                                              e.target.value
                                            )
                                          }
                                        />
                                      </Grid>
                                      <Grid item xs={3}>
                                        <Typography variant="subtitle1">
                                          Profession
                                        </Typography>
                                      </Grid>
                                      <Grid item xs={9}>
                                        <SelectDropDownNew
                                          options={professionOptions}
                                          getValues={getValues}
                                          placeholder="CandidateType"
                                          control={control}
                                          name="candidateType.name"
                                          defaultValue="none"
                                          {...register(
                                            `shifts.[${index}].profession.name`
                                          )}
                                          customOnChange={(e) =>
                                            professionOptions.map((elem) => {
                                              if (
                                                elem.value == e.target.value
                                              ) {
                                                setValue(
                                                  `shifts.[${index}].profession`,
                                                  elem.key
                                                );
                                              }
                                            })
                                          }
                                        />
                                      </Grid>

                                      <Grid item xs={3}>
                                        <Typography variant="subtitle1">
                                          Start Time
                                        </Typography>
                                      </Grid>
                                      <Grid item xs={9}>
                                        <MDInput
                                         onKeyDown={(e) => { e.key === 'Enter' && e.preventDefault() }}
                                          placeholder=""
                                          sx={{
                                            width: "100%",
                                            marginTop: "0.4rem",
                                          }}
                                          inputProps={{
                                            style: {
                                              fontSize: 15,
                                              fontWeight: "bold",
                                            },
                                          }}
                                          {...register(
                                            `shifts.[${index}].startTime`
                                          )}
                                        />
                                      </Grid>

                                      <Grid item xs={3}>
                                        <Typography variant="subtitle1">
                                          End Time
                                        </Typography>
                                      </Grid>
                                      <Grid item xs={9}>
                                        <MDInput
                                         onKeyDown={(e) => { e.key === 'Enter' && e.preventDefault() }}
                                          placeholder=""
                                          sx={{
                                            width: "100%",
                                            marginTop: "0.4rem",
                                          }}
                                          inputProps={{
                                            style: {
                                              fontSize: 15,
                                              fontWeight: "bold",
                                            },
                                          }}
                                          {...register(
                                            `shifts.[${index}].endTime`
                                          )}
                                        />
                                      </Grid>
                                    </Grid>

                                    <MDBox sx={{ textAlign: "right" }}>
                                      <MDButton
                                        variant="contained"
                                        onClick={(e) => {
                                          e.preventDefault();
                                          shiftRemove(index);
                                        }}
                                      >
                                        <Typography
                                          color="error"
                                          variant="body"
                                        >
                                          Remove
                                        </Typography>
                                      </MDButton>
                                    </MDBox>
                                  </li>
                                ))}
                                <MDButton
                                  variant="contained"
                                  color="info"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    shiftAppend({});
                                  }}
                                >
                                  + Add
                                </MDButton>
                              </ul>
                            </Paper>
                          </Grid> */}

                              {/* test papers */}

                              {/* <Grid item xs={12}>
                            <Paper sx={{ padding: "1rem" }}>
                              <Typography
                                variant="subtitle1"
                                style={{ fontWeight: 500 }}
                              >
                                Test Papers
                              </Typography>
                              <ul style={{ listStyleType: "none" }}>
                                {testField.map((field, index) => (
                                  <li>
                                    <Grid container spacing={2}>
                                      <Grid item xs={3}>
                                        <Typography variant="subtitle1">
                                          For
                                        </Typography>
                                      </Grid>
                                      <Grid item xs={9}>
                                        <SelectDropDownNew
                                          options={specializationOptions}
                                          getValues={getValues}
                                          placeholder="Specialization"
                                          control={control}
                                          {...register(
                                            `testPapers.[${index}].for.name`
                                          )}
                                          // name="specialization.name"
                                          defaultValue="none"
                                          customOnChange={(e) =>
                                            specializationOptions.map((obj) => {
                                              if (obj.value == e.target.value)
                                                setValue(
                                                  `testPapers.[${index}].for`,
                                                  obj.key
                                                );
                                            })
                                          }
                                        />
                                      </Grid>
                                    </Grid>
                                    <Grid item xs={12}>
                                      <Paper sx={{ padding: "1rem" }}>
                                        <Typography variant="h6">
                                          Questions
                                        </Typography>
                                        <hr
                                          style={{
                                            marginBottom: "2rem",
                                            marginTop: "1rem",
                                          }}
                                        />

                                        <Questions
                                          setValue={setValue}
                                          getValues={getValues}
                                          nestIndex={index}
                                          {...{ control, register }}
                                        />
                                      </Paper>
                                    </Grid>

                                    <MDBox
                                      sx={{
                                        textAlign: "right",
                                        background: "transparent",
                                        width: "100%",
                                      }}
                                    >
                                      <MDButton
                                        variant="outlined"
                                        sx={{
                                          border: "none",
                                          height: "10px",
                                          width: "30px",
                                        }}
                                        onMouseHover={{ color: "black" }}
                                        onClick={(e) => {
                                          e.preventDefault();
                                          testRemove(index);
                                        }}
                                      >
                                        <Typography
                                          color="error"
                                          sx={{ fontSize: "12px" }}
                                          onHover={{ color: "black" }}
                                        >
                                          Remove
                                        </Typography>
                                      </MDButton>
                                    </MDBox>
                                  </li>
                                ))}
                                <MDButton
                                  variant="contained"
                                  color="info"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    testAppend({});
                                  }}
                                >
                                  + Add
                                </MDButton>
                              </ul>
                            </Paper>
                          </Grid> */}

                              {/* Reverse Charges Applicable */}

                              <Grid item xs={4}>
                                <Typography
                                  variant="subtitle1"
                                  sx={{ width: "80%", marginTop: "0.8rem" }}
                                >
                                  Reverse Charges Applicable
                                </Typography>
                              </Grid>
                              <Grid item xs={8}>
                                <SelectDropDownNew
                                  control={control}
                                  options={selectedReversedOption}
                                  getValues={getValues}
                                  name="reverseChargesApplicable"
                                  placeholder="Select"
                                  customOnChange={(e) => {
                                    setValue(
                                      "reverseChargesApplicable",
                                      e.target.value,
                                    );
                                  }}
                                />
                              </Grid>

                              {/* bes size drop down */}

                              <Grid item xs={4}>
                                <Typography
                                  variant="subtitle1"
                                  sx={{ width: "80%", marginTop: "0.8rem" }}
                                >
                                  Bed Size
                                </Typography>
                              </Grid>
                              <Grid item xs={8}>
                                <SelectDropDownNew
                                  control={control}
                                  options={selectedBedSizeOption}
                                  getValues={getValues}
                                  name="bedSize"
                                  placeholder="Select"
                                  customOnChange={(e) => {
                                    setValue("bedSize", e.target.value);
                                  }}
                                />
                              </Grid>

                              {/* createdAt */}
                              <Grid item xs={4}>
                                <Typography
                                  variant="subtitle1"
                                  sx={{ width: "80%", marginTop: "0.8rem" }}
                                >
                                  Created At
                                </Typography>
                              </Grid>
                              <Grid item xs={8}>
                                <MDInput
                                  disabled
                                  placeholder=""
                                  sx={{ width: "100%", marginTop: "0.4rem" }}
                                  inputProps={{
                                    style: { fontSize: 15, fontWeight: "bold" },
                                  }}
                                  {...register("createdAt")}
                                />
                              </Grid>

                              {/* updatedAt */}
                              <Grid item xs={4}>
                                <Typography
                                  variant="subtitle1"
                                  sx={{ width: "80%", marginTop: "0.8rem" }}
                                >
                                  Created By
                                </Typography>
                              </Grid>
                              <Grid item xs={8}>
                                <MDInput
                                  disabled
                                  placeholder=""
                                  sx={{ width: "100%", marginTop: "0.4rem" }}
                                  inputProps={{
                                    style: { fontSize: 15, fontWeight: "bold" },
                                  }}
                                  // {...register("createdBy")}
                                  value={
                                    responseData[0]?.createdBy
                                      ? responseData[0]?.createdBy?.name
                                          ?.first +
                                        " " +
                                        responseData[0]?.createdBy?.name?.last
                                      : ""
                                  }
                                />
                              </Grid>

                              <Grid item xs={4}>
                                <Typography
                                  variant="subtitle1"
                                  sx={{ width: "80%", marginTop: "0.8rem" }}
                                >
                                  Updated At
                                </Typography>
                              </Grid>
                              <Grid item xs={8}>
                                <MDInput
                                  disabled
                                  placeholder=""
                                  sx={{ width: "100%", marginTop: "0.4rem" }}
                                  inputProps={{
                                    style: { fontSize: 15, fontWeight: "bold" },
                                  }}
                                  {...register("updatedAt")}
                                />
                              </Grid>

                              <Grid item xs={4}>
                                <Typography
                                  variant="subtitle1"
                                  sx={{ width: "80%", marginTop: "0.8rem" }}
                                >
                                  Updated By
                                </Typography>
                              </Grid>
                              <Grid item xs={8}>
                                <MDInput
                                  disabled
                                  placeholder=""
                                  sx={{ width: "100%", marginTop: "0.4rem" }}
                                  inputProps={{
                                    style: { fontSize: 15, fontWeight: "bold" },
                                  }}
                                  // {...register("updatedBy")}
                                  value={
                                    responseData[0]?.updatedBy
                                      ? responseData[0]?.updatedBy?.name
                                          ?.first +
                                        " " +
                                        responseData[0]?.updatedBy?.name?.last
                                      : ""
                                  }
                                />
                              </Grid>
                            </Grid>
                            <div style={{ marginTop: "2rem" }}>
                              <Button
                                type="submit"
                                variant="contained"
                                sx={{ color: "#fff" }}
                              >
                                Save
                              </Button>
                            </div>
                          </TabPanel>

                          <TabPanel value={tabValue} index={1}>
                            {/* Service Fees & Billing Preferences */}
                            <Card sx={{ p: 3, mb: 3 }}>
                              <Typography variant="h6" gutterBottom>
                                Convenience Fees & Billing Preferences
                              </Typography>
                              <Grid container spacing={3}>
                                <Grid item xs={12} md={6}>
                                  <Typography variant="subtitle1" gutterBottom>
                                    Convenience Fee (%)
                                  </Typography>
                                  {/* <MDInput
                                    fullWidth
                                    type="number"
                                    {...register("serviceFeePercent", {
                                      min: {
                                        value: 0,
                                        message:
                                          "Service fee cannot be negative",
                                      },
                                      max: {
                                        value: 100,
                                        message:
                                          "Service fee cannot exceed 100%",
                                      },
                                    })}
                                    // error={!!errors?.serviceFeePercent}
                                    // helperText={
                                    //   errors?.serviceFeePercent?.message
                                    // }
                                    placeholder="e.g., 10"
                                    InputProps={{
                                      endAdornment: (
                                        <InputAdornment position="end">
                                          %
                                        </InputAdornment>
                                      ),
                                      inputProps: {
                                        min: 0,
                                        onKeyDown: (e) => {
                                          // Prevent negative numbers from being typed
                                          if (
                                            e.key === "-" ||
                                            e.key === "e" ||
                                            e.key === "E"
                                          ) {
                                            e.preventDefault();
                                          }
                                        },
                                        onPaste: (e) => {
                                          // Prevent pasting negative numbers
                                          const pasteData =
                                            e.clipboardData.getData(
                                              "text/plain"
                                            );
                                          if (
                                            pasteData.startsWith("-") ||
                                            isNaN(pasteData)
                                          ) {
                                            e.preventDefault();
                                          }
                                        },
                                      },
                                    }}
                                    onInput={(e) => {
                                      let value = Number(e.target.value);

                                      if (value < 0) {
                                        e.target.value = 0;
                                      } else if (value > 100) {
                                        e.target.value = 100;
                                      }
                                    }}
                                    sx={{
                                      flex: 1,
                                      "& input[type=number]::-webkit-inner-spin-button":
                                        {
                                          display: "none",
                                        },
                                      "& input[type=number]::-webkit-outer-spin-button":
                                        {
                                          display: "none",
                                        },
                                      "& input[type=number]": {
                                        MozAppearance: "textfield",
                                      },
                                    }}
                                    inputProps={{
                                      style: { textAlign: "left" },
                                    }}
                                  /> */}
                                  <MDInput
                                    fullWidth
                                    type="number"
                                    step="0.01" // 👈 allow decimals
                                    {...register("serviceFeePercent", {
                                      min: {
                                        value: 0,
                                        message:
                                          "Service fee cannot be negative",
                                      },
                                      max: {
                                        value: 100,
                                        message:
                                          "Service fee cannot exceed 100%",
                                      },
                                      pattern: {
                                        value:
                                          /^(100(\.0{1,2})?|(\d{1,2})(\.\d{1,2})?)$/,
                                        message:
                                          "Enter a valid percentage (up to 2 decimals)",
                                      },
                                    })}
                                    placeholder="e.g., 10.2"
                                    InputProps={{
                                      endAdornment: (
                                        <InputAdornment position="end">
                                          %
                                        </InputAdornment>
                                      ),
                                      inputProps: {
                                        min: 0,
                                        step: "0.01",
                                        onKeyDown: (e) => {
                                          // Prevent invalid characters
                                          if (
                                            e.key === "-" ||
                                            e.key === "e" ||
                                            e.key === "E" ||
                                            e.key === "+"
                                          ) {
                                            e.preventDefault();
                                          }
                                        },
                                        onPaste: (e) => {
                                          const pasteData =
                                            e.clipboardData.getData(
                                              "text/plain",
                                            );

                                          // Allow only numbers and decimals, max 100
                                          if (
                                            !/^\d{0,3}(\.\d{0,2})?$/.test(
                                              pasteData,
                                            ) ||
                                            Number(pasteData) > 100
                                          ) {
                                            e.preventDefault();
                                          }
                                        },
                                      },
                                    }}
                                    onInput={(e) => {
                                      let value = e.target.value;

                                      // Allow empty input
                                      if (value === "") return;

                                      // Convert to number for range check
                                      const numValue = Number(value);

                                      if (numValue < 0) {
                                        e.target.value = "0";
                                      } else if (numValue > 100) {
                                        e.target.value = "100";
                                      }
                                    }}
                                    sx={{
                                      flex: 1,
                                      "& input[type=number]::-webkit-inner-spin-button":
                                        {
                                          display: "none",
                                        },
                                      "& input[type=number]::-webkit-outer-spin-button":
                                        {
                                          display: "none",
                                        },
                                      "& input[type=number]": {
                                        MozAppearance: "textfield",
                                      },
                                    }}
                                    inputProps={{
                                      style: { textAlign: "left" },
                                    }}
                                  />

                                  {/* {errors.serviceFeePercent && (
          <Typography color="error" variant="caption">
            {errors.serviceFeePercent.message}
          </Typography>
        )} */}
                                  {/* <Typography variant="caption" color="textSecondary" display="block" sx={{ mt: 1 }}>
         Percentage cannot be more than 100
        </Typography> */}
                                </Grid>

                                <Grid item xs={12} md={6}>
                                  <Typography variant="subtitle1" gutterBottom>
                                    Payment Mode
                                  </Typography>
                                  <Controller
                                    name="billingMode"
                                    control={control}
                                    // defaultValue="POSTPAID"
                                    render={({ field }) => (
                                      <SelectDropDownNew
                                        options={[
                                          { key: "PREPAID", value: "PREPAID" },
                                          {
                                            key: "POSTPAID",
                                            value: "POSTPAID",
                                          },
                                        ]}
                                        placeholder="Select Payment Mode"
                                        customOnChange={(e) => {
                                          // field.onChange(e);
                                          // Reset billing cycle when payment mode changes
                                          setValue(
                                            "billingMode",
                                            e.target.value,
                                          );
                                        }}
                                        control={control}
                                        name="billingMode"
                                        getValues={getValues}
                                      />
                                    )}
                                  />
                                </Grid>

                                {/* Billing Cycle  */}
                                {/* {watch("billingMode") === "POSTPAID" && ( */}
                                <Grid item xs={12} md={6}>
                                  <Typography variant="subtitle1" gutterBottom>
                                    Billing Cycle
                                  </Typography>
                                  <Controller
                                    name="billingCycle"
                                    control={control}
                                    defaultValue={
                                      watch("billingMode") === "PREPAID"
                                        ? "MONTHLY"
                                        : ""
                                    }
                                    render={({ field }) => (
                                      <SelectDropDownNew
                                        options={
                                          // watch("billingMode") === "PREPAID"
                                          //   ? [
                                          //       {
                                          //         key: "30",
                                          //         value: "MONTHLY",
                                          //       },
                                          //     ]
                                          //   :
                                          [
                                            {
                                              key: "15",
                                              value: "FORTNIGHTLY",
                                            },
                                            {
                                              key: "30",
                                              value: "MONTHLY",
                                            },
                                          ]
                                        }
                                        placeholder="Select Billing Cycle"
                                        customOnChange={(e) => {
                                          field.onChange(e);
                                          setValue(
                                            "billingCycle",
                                            e.target.value,
                                          );
                                        }}
                                        //       error={!!errors?.billingCycle}
                                        // helperText={
                                        //   errors?.billingCycle?.message
                                        // }
                                        control={control}
                                        name="billingCycle"
                                        getValues={getValues}
                                        // disabled={watch('billingMode') === 'PREPAID'}
                                      />
                                    )}
                                  />
                                </Grid>
                                {/* )} */}

                                {/* Buffer Days  */}
                                {watch("billingMode") === "POSTPAID" && (
                                  <Grid item xs={12} md={6}>
                                    <Typography
                                      variant="subtitle1"
                                      gutterBottom
                                    >
                                      Buffer Days
                                    </Typography>
                                    <Controller
                                      name="bufferDays"
                                      control={control}
                                      defaultValue="7 days"
                                      render={({ field }) => (
                                        <SelectDropDownNew
                                          options={[
                                            { key: "7", value: "7 days" },
                                            { key: "15", value: "15 days" },
                                            { key: "30", value: "30 days" },
                                            { key: "60", value: "60 days" },
                                            { key: "90", value: "90 days" },
                                            { key: "365", value: "365 days" },
                                          ]}
                                          placeholder="Select Buffer Days"
                                          customOnChange={(e) => {
                                            field.onChange(e);
                                            // Reset billing cycle when payment mode changes
                                            setValue(
                                              "bufferDays",
                                              e.target.value
                                            );
                                          }}
                                          control={control}
                                          name="bufferDays"
                                          getValues={getValues}
                                        />
                                      )}
                                    />
                                  </Grid>
                                )}

                                <Grid item xs={12} md={6}>
                                  <Typography variant="subtitle1" gutterBottom>
                                    Buffer Days
                                  </Typography>
                                  <Controller
                                    name="bufferDays"
                                    control={control}
                                    defaultValue="7 days"
                                    render={({ field }) => (
                                      <SelectDropDownNew
                                        options={[
                                          { key: "7", value: "7 days" },
                                          { key: "15", value: "15 days" },
                                          { key: "30", value: "30 days" },
                                          { key: "60", value: "60 days" },
                                          { key: "90", value: "90 days" },
                                          { key: "365", value: "365 days" },
                                        ]}
                                        placeholder="Select Buffer Days"
                                        customOnChange={(e) => {
                                          field.onChange(e);
                                          // Reset billing cycle when payment mode changes
                                          setValue(
                                            "bufferDays",
                                            e.target.value,
                                          );
                                        }}
                                        control={control}
                                        name="bufferDays"
                                        getValues={getValues}
                                      />
                                    )}
                                  />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                  <Typography variant="subtitle1" gutterBottom>
                                    Shift Approval Buffer Days
                                  </Typography>
                                  <Controller
                                    name="shiftApprovalBufferDays"
                                    control={control}
                                    defaultValue="7 days"
                                    render={({ field }) => (
                                      <SelectDropDownNew
                                        options={[
                                          { key: "7", value: "7 days" },
                                          { key: "15", value: "15 days" },
                                          { key: "30", value: "30 days" },
                                          { key: "60", value: "60 days" },
                                          { key: "90", value: "90 days" },
                                        ]}
                                        placeholder="Select Shift Approval Buffer Days"
                                        customOnChange={(e) => {
                                          field.onChange(e);
                                          // Reset billing cycle when payment mode changes
                                          setValue(
                                            "shiftApprovalBufferDays",
                                            e.target.value,
                                          );
                                        }}
                                        //     error={!!errors?.shiftApprovalBufferDays}
                                        // helperText={
                                        //   errors?.shiftApprovalBufferDays?.message
                                        // }
                                        control={control}
                                        name="shiftApprovalBufferDays"
                                        getValues={getValues}
                                      />
                                    )}
                                  />
                                </Grid>
                                {watch("billingMode") === "POSTPAID" && (
                                  <Grid item xs={12} md={6}>
                                    <Typography
                                      variant="subtitle1"
                                      gutterBottom
                                    >
                                      Payment Due Date
                                    </Typography>
                                    <Controller
                                      name="paymentDuePeriodDays"
                                      control={control}
                                      defaultValue="15 days"
                                      render={({ field }) => (
                                        <SelectDropDownNew
                                          options={[
                                            { key: "7", value: "7 days" },
                                            { key: "15", value: "15 days" },
                                            { key: "30", value: "30 days" },
                                            { key: "60", value: "60 days" },
                                            { key: "90", value: "90 days" },
                                          ]}
                                          placeholder="Select Payment Due Date"
                                          customOnChange={(e) => {
                                            field.onChange(e);
                                            // Reset billing cycle when payment mode changes
                                            setValue(
                                              "paymentDuePeriodDays",
                                              e.target.value,
                                            );
                                          }}
                                          //     error={!!errors?.paymentDuePeriodDays}
                                          // helperText={
                                          //   errors?.paymentDuePeriodDays?.message
                                          // }
                                          control={control}
                                          name="paymentDuePeriodDays"
                                          getValues={getValues}
                                        />
                                      )}
                                    />
                                  </Grid>
                                )}
                                <Grid item xs={12} md={6}>
                                  <Typography variant="subtitle1" gutterBottom>
                                    Late Payment Fee (%)
                                  </Typography>
                                {/* Late payment fee  */}
                                {watch("billingMode") === "POSTPAID" && (
                                  <Grid item xs={12} md={6}>
                                    <Typography
                                      variant="subtitle1"
                                      gutterBottom
                                    >
                                      Late Payment Fee (%)
                                    </Typography>
                                    <MDInput
                                      fullWidth
                                      type="number"
                                      {...register("latePaymentFeePercent", {
                                        min: {
                                          value: 0,
                                          message:
                                            "Late payment fee cannot be negative",
                                        },
                                        max: {
                                          value: 100,
                                          message:
                                            "Late payment fee cannot exceed 100%",
                                        },
                                      })}
                                      // error={!!errors?.latePaymentFeePercent}
                                      // helperText={
                                      //   errors?.latePaymentFeePercent?.message
                                      // }
                                      placeholder="e.g., 5"
                                      InputProps={{
                                        endAdornment: (
                                          <InputAdornment position="end">
                                            %
                                          </InputAdornment>
                                        ),
                                        inputProps: {
                                          min: 0,
                                          onKeyDown: (e) => {
                                            // Prevent negative numbers from being typed
                                            if (
                                              e.key === "-" ||
                                              e.key === "e" ||
                                              e.key === "E"
                                            ) {
                                              e.preventDefault();
                                            }
                                          },
                                          onPaste: (e) => {
                                            // Prevent pasting negative numbers
                                            const pasteData =
                                              e.clipboardData.getData(
                                                "text/plain"
                                              );
                                            if (
                                              pasteData.startsWith("-") ||
                                              isNaN(pasteData)
                                            ) {
                                              e.preventDefault();
                                            }
                                          },
                                        },
                                      }}
                                      onInput={(e) => {
                                        let value = Number(e.target.value);

                                        if (value < 0) {
                                          e.target.value = 0;
                                        } else if (value > 100) {
                                          e.target.value = 100;
                                        }
                                      }}
                                      sx={{
                                        flex: 1,
                                        "& input[type=number]::-webkit-inner-spin-button":
                                          {
                                            display: "none",
                                          },
                                        "& input[type=number]::-webkit-outer-spin-button":
                                          {
                                            display: "none",
                                          },
                                        "& input[type=number]": {
                                          MozAppearance: "textfield",
                                        },
                                      }}
                                      inputProps={{
                                        style: { textAlign: "left" },
                                      }}
                                    />
                                  </Grid>
                                )}

                                <Grid item xs={12} md={6}>
                                  <Typography variant="subtitle1" gutterBottom>
                                    Platform Fee
                                  </Typography>
                                  <MDInput
                                    fullWidth
                                    defaultValue="0"
                                    type="number"
                                    {...register("platformFeePercent", {
                                      min: {
                                        value: 0,
                                        message:
                                          "Platform fee cannot be negative",
                                      },
                                      max: {
                                        value: 100,
                                        message:
                                          "Platform fee cannot exceed 100%",
                                      },
                                    })}
                                    // error={!!errors?.latePaymentFeePercent}
                                    // helperText={
                                    //   errors?.latePaymentFeePercent?.message
                                    // }
                                    placeholder="e.g., 5"
                                    InputProps={{
                                      endAdornment: (
                                        <InputAdornment position="end">
                                          %
                                        </InputAdornment>
                                      ),
                                      inputProps: {
                                        min: 0,
                                        onKeyDown: (e) => {
                                          // Prevent negative numbers from being typed
                                          if (
                                            e.key === "-" ||
                                            e.key === "e" ||
                                            e.key === "E"
                                          ) {
                                            e.preventDefault();
                                          }
                                        },
                                        onPaste: (e) => {
                                          // Prevent pasting negative numbers
                                          const pasteData =
                                            e.clipboardData.getData(
                                              "text/plain",
                                            );
                                          if (
                                            pasteData.startsWith("-") ||
                                            isNaN(pasteData)
                                          ) {
                                            e.preventDefault();
                                          }
                                        },
                                      },
                                    }}
                                    onInput={(e) => {
                                      let value = Number(e.target.value);

                                      if (value < 0) {
                                        e.target.value = 0;
                                      } else if (value > 100) {
                                        e.target.value = 100;
                                      }
                                    }}
                                    sx={{
                                      flex: 1,
                                      "& input[type=number]::-webkit-inner-spin-button":
                                        {
                                          display: "none",
                                        },
                                      "& input[type=number]::-webkit-outer-spin-button":
                                        {
                                          display: "none",
                                        },
                                      "& input[type=number]": {
                                        MozAppearance: "textfield",
                                      },
                                    }}
                                    inputProps={{
                                      style: { textAlign: "left" },
                                    }}
                                  />
                                  {/* <Typography variant="caption" color="textSecondary" display="block" sx={{ mt: 1 }}>
         Percentage cannot be more than 100
        </Typography> */}
                                  {/* {errors.fees?.latePaymentFee && (
          <Typography color="error" variant="caption">
            {errors.fees.latePaymentFee.message}
          </Typography>
        )} */}
                                </Grid>
                                {watch("billingMode") === "PREPAID" && (
                                  <>
                                    <Grid item xs={12} md={6}>
                                      <Typography
                                        variant="subtitle1"
                                        gutterBottom
                                      >
                                        Threshold Cap
                                      </Typography>
                                      <MDInput
                                        fullWidth
                                        defaultValue="0"
                                        type="number"
                                        {...register(
                                          "prepaidWallet.thresholdCap",
                                          {}
                                        )}
                                        // error={!!errors?.latePaymentFeePercent}
                                        // helperText={
                                        //   errors?.latePaymentFeePercent?.message
                                        // }
                                        placeholder="e.g., 5"
                                        InputProps={{
                                          // endAdornment: (
                                          //   <InputAdornment position="end">
                                          //     %
                                          //   </InputAdornment>
                                          // ),
                                          inputProps: {
                                            min: 0,
                                            onKeyDown: (e) => {
                                              // Prevent negative numbers from being typed
                                              if (
                                                e.key === "-" ||
                                                e.key === "e" ||
                                                e.key === "E"
                                              ) {
                                                e.preventDefault();
                                              }
                                            },
                                            onPaste: (e) => {
                                              // Prevent pasting negative numbers
                                              const pasteData =
                                                e.clipboardData.getData(
                                                  "text/plain"
                                                );
                                              if (
                                                pasteData.startsWith("-") ||
                                                isNaN(pasteData)
                                              ) {
                                                e.preventDefault();
                                              }
                                            },
                                          },
                                        }}
                                        onInput={(e) => {
                                          let value = Number(e.target.value);

                                          if (value < 0) {
                                            e.target.value = 0;
                                          } else if (value > 100) {
                                            e.target.value = 100;
                                          }
                                        }}
                                        sx={{
                                          flex: 1,
                                          "& input[type=number]::-webkit-inner-spin-button":
                                            {
                                              display: "none",
                                            },
                                          "& input[type=number]::-webkit-outer-spin-button":
                                            {
                                              display: "none",
                                            },
                                          "& input[type=number]": {
                                            MozAppearance: "textfield",
                                          },
                                        }}
                                        inputProps={{
                                          style: { textAlign: "left" },
                                        }}
                                      />
                                      {/* <Typography variant="caption" color="textSecondary" display="block" sx={{ mt: 1 }}>
         Percentage cannot be more than 100
        </Typography> */}
                                      {/* {errors.fees?.latePaymentFee && (
          <Typography color="error" variant="caption">
            {errors.fees.latePaymentFee.message}
          </Typography>
        )} */}
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                      <Typography
                                        variant="subtitle1"
                                        gutterBottom
                                      >
                                        Threshold Percentage
                                      </Typography>
                                      <MDInput
                                        fullWidth
                                        defaultValue="0"
                                        type="number"
                                        {...register(
                                          "prepaidWallet.thresholdPercentage",
                                          {
                                            min: {
                                              value: 0,
                                              message:
                                                "Threshold Percentage cannot be negative",
                                            },
                                            max: {
                                              value: 100,
                                              message:
                                                "Threshold Percentage cannot exceed 100%",
                                            },
                                          }
                                        )}
                                        // error={!!errors?.latePaymentFeePercent}
                                        // helperText={
                                        //   errors?.latePaymentFeePercent?.message
                                        // }
                                        placeholder="e.g., 5"
                                        InputProps={{
                                          endAdornment: (
                                            <InputAdornment position="end">
                                              %
                                            </InputAdornment>
                                          ),
                                          inputProps: {
                                            min: 0,
                                            onKeyDown: (e) => {
                                              // Prevent negative numbers from being typed
                                              if (
                                                e.key === "-" ||
                                                e.key === "e" ||
                                                e.key === "E"
                                              ) {
                                                e.preventDefault();
                                              }
                                            },
                                            onPaste: (e) => {
                                              // Prevent pasting negative numbers
                                              const pasteData =
                                                e.clipboardData.getData(
                                                  "text/plain"
                                                );
                                              if (
                                                pasteData.startsWith("-") ||
                                                isNaN(pasteData)
                                              ) {
                                                e.preventDefault();
                                              }
                                            },
                                          },
                                        }}
                                        onInput={(e) => {
                                          let value = Number(e.target.value);

                                          if (value < 0) {
                                            e.target.value = 0;
                                          } else if (value > 100) {
                                            e.target.value = 100;
                                          }
                                        }}
                                        sx={{
                                          flex: 1,
                                          "& input[type=number]::-webkit-inner-spin-button":
                                            {
                                              display: "none",
                                            },
                                          "& input[type=number]::-webkit-outer-spin-button":
                                            {
                                              display: "none",
                                            },
                                          "& input[type=number]": {
                                            MozAppearance: "textfield",
                                          },
                                        }}
                                        inputProps={{
                                          style: { textAlign: "left" },
                                        }}
                                      />
                                      {/* <Typography variant="caption" color="textSecondary" display="block" sx={{ mt: 1 }}>
         Percentage cannot be more than 100
        </Typography> */}
                                      {/* {errors.fees?.latePaymentFee && (
          <Typography color="error" variant="caption">
            {errors.fees.latePaymentFee.message}
          </Typography>
        )} */}
                                    </Grid>
                                  </>
                                )}
                                  
                              </Grid>
                              </Grid>
                            </Card>

                            {/* Contact Information */}
                            <Card sx={{ p: 3, mb: 3 }}>
                              <Typography variant="h6" gutterBottom>
                                Contact Information
                              </Typography>
                              <Grid container spacing={3}>
                                <Grid item xs={12} md={6}>
                                  <Typography variant="subtitle1" gutterBottom>
                                    HR Email{" "}
                                    <span style={{ color: "red" }}>*</span>
                                  </Typography>

                                  <MDInput
                                    fullWidth
                                    type="email"
                                    placeholder="hr@example.com"
                                    {...register("hrEmail", {
                                      // required: isNewBranch ? "HR Email is required" : false,
                                      pattern: {
                                        value:
                                          /^(?=[a-zA-Z0-9])[a-zA-Z0-9._%+-]*[a-zA-Z0-9]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                                        message: "Invalid email address",
                                      },
                                    })}
                                    // error={!!errors?.hrEmail}
                                    // helperText={errors?.hrEmail?.message || ' '}
                                  />
                                </Grid>

                                {/* HR Contact */}
                                <Grid item xs={12} md={6}>
                                  <Typography variant="subtitle1" gutterBottom>
                                    HR Contact{" "}
                                    <span style={{ color: "red" }}>*</span>
                                  </Typography>
                                  <MDInput
                                    fullWidth
                                    {...register("hrContact", {
                                      // required: isNewBranch ?'HR Contact is required':false,
                                      pattern: {
                                        value: /^[0-9]{10}$/,
                                        message:
                                          "Please enter a valid 10-digit phone number",
                                      },
                                      onChange: (e) => {
                                        // Allow only numbers and limit to 10 digits
                                        e.target.value = e.target.value
                                          .replace(/\D/g, "")
                                          .slice(0, 10);
                                      },
                                    })}
                                    placeholder="Enter 10-digit mobile number"
                                    // error={!!errors?.hrContact}
                                    // helperText={errors?.hrContact?.message || ' '}
                                    inputProps={{
                                      inputMode: "numeric",
                                      pattern: "[0-9]*",
                                      maxLength: 10,
                                    }}
                                    sx={{
                                      flex: 1,
                                      "& input[type=number]::-webkit-inner-spin-button":
                                        {
                                          display: "none",
                                        },
                                      "& input[type=number]::-webkit-outer-spin-button":
                                        {
                                          display: "none",
                                        },
                                      "& input[type=number]": {
                                        MozAppearance: "textfield",
                                      },
                                    }}
                                  />
                                </Grid>

                                {/* Finance Email */}
                                <Grid item xs={12} md={6}>
                                  <Typography variant="subtitle1" gutterBottom>
                                    Finance Email{" "}
                                    <span style={{ color: "red" }}>*</span>
                                  </Typography>
                                  <MDInput
                                    fullWidth
                                    type="email"
                                    {...register("financeEmail", {
                                      // required: isNewBranch ?'Finance Email is required':false,
                                      pattern: {
                                        value:
                                          /^(?=[a-zA-Z0-9])[a-zA-Z0-9._%+-]*[a-zA-Z0-9]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                                        message: "Invalid email address",
                                      },
                                    })}
                                    placeholder="finance@example.com"
                                    // error={!!errors?.financeEmail}
                                    // helperText={errors?.financeEmail?.message || ' '}
                                  />
                                </Grid>

                                {/* Finance Contact */}
                                <Grid item xs={12} md={6}>
                                  <Typography variant="subtitle1" gutterBottom>
                                    Finance Contact{" "}
                                    <span style={{ color: "red" }}>*</span>
                                  </Typography>
                                  <MDInput
                                    fullWidth
                                    {...register("financeContact", {
                                      // required: isNewBranch ?'Finance Contact is required':false,
                                      pattern: {
                                        value: /^[0-9]{10}$/,
                                        message:
                                          "Please enter a valid 10-digit phone number",
                                      },
                                      onChange: (e) => {
                                        // Allow only numbers and limit to 10 digits
                                        e.target.value = e.target.value
                                          .replace(/\D/g, "")
                                          .slice(0, 10);
                                      },
                                    })}
                                    placeholder="Enter 10-digit mobile number"
                                    // error={!!errors?.financeContact}
                                    // helperText={errors?.financeContact?.message || ' '}
                                    inputProps={{
                                      inputMode: "numeric",
                                      pattern: "[0-9]*",
                                      maxLength: 10,
                                    }}
                                  />
                                </Grid>

                                <Grid item xs={12} md={6}>
                                  <Typography variant="subtitle1" gutterBottom>
                                    Other Email (Optional)
                                  </Typography>
                                  <MDInput
                                    fullWidth
                                    type="text"
                                    {...register("otherEmail", {
                                      validate: {
                                        validEmails: (value) => {
                                          if (!value) return true; // Skip validation if empty (since it's optional)
                                          const emails = value
                                            .split(",")
                                            .map((email) => email.trim());
                                          const emailRegex =
                                            /^(?=[a-zA-Z0-9])[a-zA-Z0-9._%+-]*[a-zA-Z0-9]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/i;
                                          const invalidEmail = emails.find(
                                            (email) =>
                                              email && !emailRegex.test(email),
                                          );
                                          return (
                                            !invalidEmail ||
                                            "One or more email addresses are invalid"
                                          );
                                        },
                                      },
                                    })}
                                    placeholder="email1@example.com, email2@example.com"
                                    onBlur={(e) => {
                                      // Convert comma-separated string to array on blur
                                      const value = e.target.value;
                                      if (value) {
                                        const emails = value
                                          .split(",")
                                          .map((email) => email.trim());
                                        setValue(
                                          "otherEmail",
                                          emails.join(", "),
                                        ); // Display with space after comma
                                        setValue("otherEmailArray", emails); // Store as array for form submission
                                      }
                                    }}
                                  />
                                  <Typography
                                    variant="caption"
                                    color="textSecondary"
                                  >
                                    Separate multiple emails with commas
                                  </Typography>
                                </Grid>

                                <Grid item xs={12} md={6}>
                                  <Typography variant="subtitle1" gutterBottom>
                                    Other Contact (Optional)
                                  </Typography>
                                  <MDInput
                                    fullWidth
                                    type="text"
                                    {...register("otherPhone", {
                                      validate: {
                                        validPhoneNumbers: (value) => {
                                          if (!value) return true; // Skip validation if empty (since it's optional)
                                          const contacts = value
                                            .split(",")
                                            .map((contact) => contact.trim());
                                          const phoneRegex = /^[0-9]{10}$/; // Only allow 10-digit numbers
                                          const invalidPhone = contacts.find(
                                            (contact) =>
                                              contact &&
                                              !phoneRegex.test(contact),
                                          );
                                          return (
                                            !invalidPhone ||
                                            "One or more phone numbers are invalid"
                                          );
                                        },
                                      },
                                    })}
                                    placeholder="+91 XXXXXXXXXX, +91 YYYYYYYYYY"
                                    onBlur={(e) => {
                                      // Convert comma-separated string to array on blur
                                      const value = e.target.value;
                                      if (value) {
                                        const contacts = value
                                          .split(",")
                                          .map((contact) => contact.trim());
                                        setValue(
                                          "otherPhone",
                                          contacts.join(", "),
                                        ); // Display with space after comma
                                        setValue("otherPhoneArray", contacts); // Store as array for form submission
                                      }
                                    }}
                                  />
                                  <Typography
                                    variant="caption"
                                    color="textSecondary"
                                  >
                                    Separate multiple contacts with commas
                                  </Typography>
                                </Grid>
                              </Grid>
                            </Card>

                            {/* Billing Information */}
                            <Card sx={{ p: 3, mb: 3 }}>
                              <Typography variant="h6" gutterBottom>
                                Billing Details
                              </Typography>
                              <Grid container spacing={3}>
                                {/* Billing Name */}
                                <Grid item xs={12} md={6}>
                                  <Typography variant="subtitle1" gutterBottom>
                                    Billing Name{" "}
                                    <span style={{ color: "red" }}>*</span>
                                  </Typography>
                                  <MDInput
                                    fullWidth
                                    {...register("billingName", {
                                      // required: isNewBranch ?'Billing Name is required':false,
                                      // minLength: { value: 2, message: 'Name must be at least 2 characters' },
                                      // maxLength: { value: 100, message: 'Name must be less than 100 characters' },
                                      // pattern: {
                                      //   value: /^[A-Za-z\s-]+$/,
                                      //   message: 'Only letters, spaces and hyphens are allowed'
                                      // },
                                      // onChange: (e) => {
                                      //   // Allow only letters, spaces and hyphens
                                      //   e.target.value = e.target.value.replace(/[^A-Za-z\s-]/g, '');
                                      // }
                                    })}
                                    placeholder="Enter Billing Name"
                                    // error={!!errors?.billingName}
                                    // helperText={errors?.billingName?.message || ' '}
                                  />
                                </Grid>

                                {/* Complete Billing Address */}
                                <Grid item xs={12} md={6}>
                                  <Typography variant="subtitle1" gutterBottom>
                                    Billing Address{" "}
                                    <span style={{ color: "red" }}>*</span>
                                  </Typography>
                                  <MDInput
                                    fullWidth
                                    {...register("completeBillingAddress", {
                                      // required: isNewBranch ?'Billing Address is required':false,
                                      minLength: {
                                        value: 5,
                                        message:
                                          "Address must be at least 5 characters",
                                      },
                                      maxLength: {
                                        value: 500,
                                        message:
                                          "Address must be less than 500 characters",
                                      },
                                    })}
                                    placeholder="Enter Complete Billing Address"
                                    // error={!!errors?.completeBillingAddress}
                                    // helperText={errors?.completeBillingAddress?.message || ' '}
                                    // multiline
                                    // rows={2}
                                  />
                                </Grid>

                                {/* City & State */}
                                <Grid item xs={12} md={6}>
                                  <Typography variant="subtitle1" gutterBottom>
                                    City <span style={{ color: "red" }}>*</span>
                                  </Typography>

                                  <Controller
                                    control={control}
                                    name="billingCity"
                                    render={({ field }) => (
                                      <Autocomplete
                                        options={cityOptions}
                                        popupIcon={<KeyboardArrowDownIcon />}
                                        getOptionLabel={(option) =>
                                          option?.value || ""
                                        }
                                        value={
                                          cityOptions.find(
                                            (opt) => opt.value === field.value,
                                          ) || null
                                        }
                                        onChange={(e, newValue) => {
                                          const value =
                                            newValue?.value || field.value;
                                          field.onChange(value);
                                          setValue("billingCity", value);
                                        }}
                                        fullWidth
                                        ListboxProps={{
                                          style: { maxHeight: 250 },
                                        }}
                                        sx={{
                                          "& .MuiOutlinedInput-root": {
                                            height: 40,
                                            borderRadius: "6px",
                                          },
                                          "& .MuiAutocomplete-input": {
                                            fontSize: "16px",
                                            fontWeight: 700,
                                            color: "#6b7a99",
                                          },
                                          "& .MuiSvgIcon-root": {
                                            color: "#6b7a99",
                                            fontSize: "20px",
                                          },
                                        }}
                                        renderOption={(props, option) => (
                                          <li
                                            {...props}
                                            style={{
                                              fontSize: "15px",
                                              fontWeight: 500,
                                              padding: "10px",
                                            }}
                                          >
                                            {option.value}
                                          </li>
                                        )}
                                        renderInput={(params) => (
                                          <TextField
                                            {...params}
                                            placeholder="Select"
                                            size="small"
                                          />
                                        )}
                                      />
                                    )}
                                  />
                                  {/* <SelectDropDownNew
                                    options={cityOptions}
                                    name={`billingCity`}
                                    getValues={getValues}
                                    control={control}
                                    defaultValue="none"
                                    setValue={setValue}
                                    placeholder="Select"
                                    customOnChange={(e) => {
                                      setValue(`billingCity`, e.target.value);
                                    }}
                                    // helperText={
                                    //   errors?.billingCity?.message
                                    // }

                                    fullWidth
                                    {...register("billingCity", {
                                      // required: isNewBranch ?'Billing City is required':false,
                                      minLength: {
                                        value: 2,
                                        message:
                                          "City name must be at least 2 characters",
                                      },
                                      maxLength: {
                                        value: 100,
                                        message:
                                          "City name must be less than 100 characters",
                                      },
                                      pattern: {
                                        value: /^[A-Za-z\s-]+$/,
                                        message:
                                          "Only letters, spaces and hyphens are allowed",
                                      },
                                      onChange: (e) => {
                                        // Allow only letters, spaces and hyphens
                                        e.target.value = e.target.value.replace(
                                          /[^A-Za-z\s-]/g,
                                          ""
                                        );
                                      },
                                    })}
                                  /> */}
                                </Grid>

                                {/* Billing State */}
                                {/* <Grid item xs={12} md={6}>
                                  <Typography variant="subtitle1" gutterBottom>
                                    State{" "}
                                    <span style={{ color: "red" }}>*</span>
                                  </Typography>

                                  <SelectDropDownNew
                                    options={indianStates}
                                    name={`billingState`}
                                    getValues={getValues}
                                    control={control}
                                    defaultValue="none"
                                    setValue={setValue}
                                    placeholder="Select"
                                    customOnChange={(e) => {
                                      setValue(`billingState`, e.target.value);
                                    }}
                                    fullWidth
                                    {...register("billingState", {
                                      onChange: (e) => {
                                        e.target.value = e.target.value.replace(
                                          /[^A-Za-z\s-]/g,
                                          ""
                                        );
                                      },
                                    })}
                                  />
                                </Grid> */}

                                <Grid item xs={12} md={6}>
                                  <Typography variant="subtitle1" gutterBottom>
                                    State{" "}
                                    <span style={{ color: "red" }}>*</span>
                                  </Typography>

                                  <Controller
                                    control={control}
                                    name="billingState"
                                    render={({ field }) => (
                                      <Autocomplete
                                        options={indianStates}
                                        popupIcon={<KeyboardArrowDownIcon />}
                                        getOptionLabel={(option) =>
                                          option?.value || ""
                                        }
                                        value={
                                          indianStates.find(
                                            (opt) => opt.value === field.value,
                                          ) || null
                                        }
                                        onChange={(e, newValue) => {
                                          const value =
                                            newValue?.value || field.value;
                                          field.onChange(value);
                                          setValue("billingState", value);
                                        }}
                                        fullWidth
                                        ListboxProps={{
                                          style: { maxHeight: 250 },
                                        }}
                                        sx={{
                                          "& .MuiOutlinedInput-root": {
                                            height: 40,
                                            borderRadius: "6px",
                                          },
                                          "& .MuiAutocomplete-input": {
                                            fontSize: "16px",
                                            fontWeight: 700,
                                            color: "#6b7a99",
                                          },
                                          "& .MuiSvgIcon-root": {
                                            color: "#6b7a99",
                                            fontSize: "20px",
                                          },
                                        }}
                                        renderOption={(props, option) => (
                                          <li
                                            {...props}
                                            style={{
                                              fontSize: "15px",
                                              fontWeight: 500,
                                              padding: "10px",
                                            }}
                                          >
                                            {option.value}
                                          </li>
                                        )}
                                        renderInput={(params) => (
                                          <TextField
                                            {...params}
                                            placeholder="Select"
                                            size="small"
                                          />
                                        )}
                                      />
                                    )}
                                  />
                                </Grid>

                                {/* <Grid item xs={12} md={6}>
                                  <Typography variant="subtitle1" gutterBottom>
                                    State{" "}
                                    <span style={{ color: "red" }}>*</span>
                                  </Typography>
                                  <MDInput
                                    fullWidth
                                    {...register("billingState", {
                                      // required: isNewBranch ?'Billing State is required':false,
                                      minLength: {
                                        value: 2,
                                        message:
                                          "State name must be at least 2 characters",
                                      },
                                      maxLength: {
                                        value: 100,
                                        message:
                                          "State name must be less than 100 characters",
                                      },
                                      pattern: {
                                        value: /^[A-Za-z\s-]+$/,
                                        message:
                                          "Only letters, spaces and hyphens are allowed",
                                      },
                                      onChange: (e) => {
                                        // Allow only letters, spaces and hyphens
                                        e.target.value = e.target.value.replace(
                                          /[^A-Za-z\s-]/g,
                                          ""
                                        );
                                      },
                                    })}
                                    placeholder="Enter Billing State"
                                    // error={!!errors?.billingState}
                                    // helperText={errors?.billingState?.message || ' '}
                                  />
                                </Grid> */}

                                {/* Billing Country */}
                                <Grid item xs={12} md={6}>
                                  <Typography variant="subtitle1" gutterBottom>
                                    Country{" "}
                                    <span style={{ color: "red" }}>*</span>
                                  </Typography>
                                  <MDInput
                                    fullWidth
                                    {...register("billingCountry", {
                                      // required: isNewBranch ?'Billing Country is required':false,
                                      minLength: {
                                        value: 2,
                                        message:
                                          "Country name must be at least 2 characters",
                                      },
                                      maxLength: {
                                        value: 100,
                                        message:
                                          "Country name must be less than 100 characters",
                                      },
                                      pattern: {
                                        value: /^[A-Za-z\s-]+$/,
                                        message:
                                          "Only letters, spaces and hyphens are allowed",
                                      },
                                      onChange: (e) => {
                                        // Allow only letters, spaces and hyphens
                                        e.target.value = e.target.value.replace(
                                          /[^A-Za-z\s-]/g,
                                          "",
                                        );
                                      },
                                    })}
                                    placeholder="Enter Billing Country"
                                    // error={!!errors?.billingCountry}
                                    // helperText={errors?.billingCountry?.message || ' '}
                                  />
                                </Grid>

                                {/* Billing Pin Code */}
                                <Grid item xs={12} md={6}>
                                  <Typography variant="subtitle1" gutterBottom>
                                    Pin Code{" "}
                                    <span style={{ color: "red" }}>*</span>
                                  </Typography>
                                  <MDInput
                                    fullWidth
                                    type="text"
                                    {...register("billingPinCode", {
                                      // required: isNewBranch ?'Billing Pin Code is required':false,
                                      pattern: {
                                        value: /^[0-9]{6}$/,
                                        message:
                                          "Pincode must be exactly 6 digits",
                                      },
                                      onChange: (e) => {
                                        // Allow only numbers and limit to 6 digits
                                        e.target.value = e.target.value
                                          .replace(/\D/g, "")
                                          .slice(0, 6);
                                      },
                                    })}
                                    placeholder="Enter 6-digit Pin Code"
                                    // error={!!errors?.billingPinCode}
                                    // helperText={errors?.billingPinCode?.message || ' '}
                                    inputProps={{
                                      inputMode: "numeric",
                                      pattern: "[0-9]*",
                                      maxLength: 6,
                                    }}
                                  />
                                </Grid>

                                {/* Yes / No radio between Pin Code and GST Number */}
                                <Grid item xs={12} md={12}>
                                  <Typography variant="subtitle1" gutterBottom>
                                    Is GST Available{" "}
                                    <span style={{ color: "red" }}>*</span>
                                  </Typography>
                                  <Controller
                                    name="isGSTAvailable"
                                    control={control}
                                    // defaultValue=""
                                    defaultValue={
                                      responseData[0]?.billingInfo?.gstDetails
                                        ?.isGSTAvailable === "YES"
                                        ? "yes"
                                        : responseData[0]?.billingInfo
                                              ?.gstDetails?.isGSTAvailable ===
                                            "NO"
                                          ? "no"
                                          : ""
                                    }
                                    // value={
                                    //   responseData[0]?.billingInfo?.gstDetails?.isGSTAvailable === "YES"
                                    //     ? "yes"
                                    //     : "no"
                                    // }
                                    render={({ field }) => (
                                      <RadioGroup
                                        row // horizontal yes/no
                                        {...field}
                                        onChange={(e) => {
                                          setGstAvailable(e.target.value);
                                          field.onChange(e.target.value);

                                          if (e.target.value === "no") {
                                            setValue("gstNumber", "");
                                            gstErrorShown.current = false;
                                          }
                                        }}
                                      >
                                        <FormControlLabel
                                          value="yes"
                                          control={<Radio />}
                                          label="Yes"
                                        />
                                        <FormControlLabel
                                          value="no"
                                          control={<Radio />}
                                          label="No"
                                        />
                                      </RadioGroup>
                                    )}
                                  />
                                </Grid>

                                {gstAvailable === "yes" && (
                                  <>
                                    {/* GST Number */}
                                    <Grid item xs={12} md={6}>
                                      <Typography
                                        variant="subtitle1"
                                        gutterBottom
                                      >
                                        GST Number{" "}
                                        <span style={{ color: "red" }}>*</span>
                                      </Typography>
                                      <MDInput
                                        fullWidth
                                        {...register("gstNumber", {
                                          pattern: {
                                            // value: /^[A-Z0-9]+$/,
                                            value:
                                              /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z][1-9A-Z]Z[0-9A-Z]$/,
                                            message:
                                              "Only alphanumeric characters are allowed",
                                          },

                                          onChange: (e) => {
                                            // Auto-uppercase and remove non-alphanumeric characters
                                            let value = e.target.value
                                              .toUpperCase()
                                              .replace(/[^A-Z0-9]/g, "");

                                            e.target.value = value;
                                            const selectedState =
                                              watch("billingState");
                                            const expectedCode =
                                              stateCodes?.[selectedState];

                                            if (
                                              value.length >= 2 &&
                                              expectedCode
                                            ) {
                                              const gstCode = value.substring(
                                                0,
                                                2,
                                              );

                                              if (gstCode !== expectedCode) {
                                                if (!gstErrorShown.current) {
                                                  toast.error(
                                                    `GST should start with ${expectedCode} for ${selectedState}`,
                                                  );
                                                  gstErrorShown.current = true;
                                                }
                                              } else {
                                                gstErrorShown.current = false;
                                              }
                                            }
                                          },
                                        })}
                                        placeholder="Enter GST Number (e.g., 22AAAAA0000A1Z5)"
                                        // error={!!errors?.gstNumber}
                                        // helperText={errors?.gstNumber?.message || ' '}
                                        inputProps={{ maxLength: 15 }}
                                        style={{ textTransform: "uppercase" }}
                                      />
                                    </Grid>

                                    {/* GST Certificate */}
                                    <Grid item xs={12} md={6}>
                                      <Typography
                                        variant="subtitle1"
                                        gutterBottom
                                      >
                                        GST Certificate (Optional)
                                        {/* <span style={{ color: "red" }}>*</span> */}
                                      </Typography>
                                      {uploadedFiles.gst ? (
                                        <Box
                                          sx={{
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "space-between",
                                            p: 1,
                                            border: "1px solid #ccc",
                                            borderRadius: 1,
                                          }}
                                        >
                                          <Box
                                            sx={{
                                              display: "flex",
                                              alignItems: "center",
                                              gap: 1,
                                            }}
                                          >
                                            <DescriptionIcon color="primary" />
                                            <Box>
                                              <Typography variant="body2">
                                                {uploadedFiles.gst.name}
                                              </Typography>
                                            </Box>
                                          </Box>
                                          <Box>
                                            <IconButton
                                              size="small"
                                              color="primary"
                                              onClick={() =>
                                                window.open(
                                                  uploadedFiles.gst.url,
                                                  "_blank",
                                                )
                                              }
                                              title="View Certificate"
                                            >
                                              <VisibilityIcon />
                                            </IconButton>
                                            <IconButton
                                              size="small"
                                              color="error"
                                              onClick={() =>
                                                handleFileRemove("gst")
                                              }
                                              title="Remove File"
                                            >
                                              <DeleteIcon />
                                            </IconButton>
                                          </Box>
                                        </Box>
                                      ) : (
                                        <Button
                                          variant="outlined"
                                          component="label"
                                          startIcon={<CloudUpload />}
                                          fullWidth
                                          sx={{ color: "grey" }}
                                        >
                                          Upload GST Certificate
                                          <input
                                            type="file"
                                            hidden
                                            accept=".pdf,.jpg,.jpeg,.png"
                                            ref={gstFileInputRef}
                                            onChange={(e) =>
                                              handleFileUpload(e, "gst")
                                            }
                                          />
                                        </Button>
                                      )}
                                    </Grid>
                                  </>
                                )}

                                {gstAvailable === "no" && (
                                  <>
                                    {/* Decleration data */}
                                    <Grid item xs={12} md={12}>
                                      <Typography
                                        variant="subtitle1"
                                        gutterBottom
                                      >
                                        Declaration (Optional)
                                        {/* <span style={{ color: "red" }}>*</span> */}
                                      </Typography>
                                      {uploadedFiles.decleration ? (
                                        <Box
                                          sx={{
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "space-between",
                                            p: 2,
                                            border: "1px solid #e0e0e0",
                                            borderRadius: 1,
                                            backgroundColor: "#f9f9f9",
                                          }}
                                        >
                                          <Box
                                            sx={{
                                              display: "flex",
                                              alignItems: "center",
                                              gap: 2,
                                            }}
                                          >
                                            <DescriptionIcon color="primary" />
                                            <Box>
                                              <Typography variant="body2">
                                                {uploadedFiles.decleration.name}
                                              </Typography>
                                            </Box>
                                          </Box>
                                          <Box>
                                            <IconButton
                                              size="small"
                                              color="primary"
                                              onClick={() =>
                                                window.open(
                                                  uploadedFiles.decleration.url,
                                                  "_blank",
                                                )
                                              }
                                              title="View Decleration"
                                            >
                                              <VisibilityIcon />
                                            </IconButton>
                                            <IconButton
                                              size="small"
                                              color="error"
                                              onClick={() =>
                                                handleFileRemove("decleration")
                                              }
                                              title="Remove File"
                                            >
                                              <DeleteIcon />
                                            </IconButton>
                                          </Box>
                                        </Box>
                                      ) : (
                                        <Button
                                          variant="outlined"
                                          component="label"
                                          fullWidth
                                          startIcon={<CloudUpload />}
                                          sx={{ color: "grey" }}
                                        >
                                          Upload Declaration
                                          <input
                                            type="file"
                                            hidden
                                            accept=".pdf,.jpg,.jpeg,.png"
                                            ref={declerationFileInputRef}
                                            onChange={(e) =>
                                              handleFileUpload(e, "decleration")
                                            }
                                          />
                                        </Button>
                                      )}
                                    </Grid>
                                  </>
                                )}
                                {/* PAN Number */}
                                <Grid item xs={12} md={6}>
                                  <Typography variant="subtitle1" gutterBottom>
                                    PAN Number (Optional)
                                    {/* <span style={{ color: "red" }}>*</span> */}
                                  </Typography>
                                  <MDInput
                                    fullWidth
                                    {...register("panNumber", {
                                      // required: isNewBranch ?'PAN Number is required':false,
                                      pattern: {
                                        value: /^[A-Z0-9]+$/,
                                        message:
                                          "Only alphanumeric characters are allowed",
                                      },
                                      onChange: (e) => {
                                        // Auto-uppercase and remove non-alphanumeric characters
                                        e.target.value = e.target.value
                                          .toUpperCase()
                                          .replace(/[^A-Z0-9]/g, "");
                                      },
                                    })}
                                    placeholder="Enter PAN Number (e.g., ABCDE1234F)"
                                    // error={!!errors?.panNumber}
                                    // helperText={errors?.panNumber?.message || ' '}

                                    style={{ textTransform: "uppercase" }}
                                    inputProps={{
                                      maxLength: 10,
                                    }}
                                  />
                                </Grid>

                                <Grid item xs={12} md={6}>
                                  <Typography variant="subtitle1" gutterBottom>
                                    PAN Card (Optional)
                                    {/* <span style={{ color: "red" }}>*</span> */}
                                  </Typography>
                                  {uploadedFiles.pan ? (
                                    <Box
                                      sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "space-between",
                                        p: 2,
                                        border: "1px solid #e0e0e0",
                                        borderRadius: 1,
                                        backgroundColor: "#f9f9f9",
                                      }}
                                    >
                                      <Box
                                        sx={{
                                          display: "flex",
                                          alignItems: "center",
                                          gap: 2,
                                        }}
                                      >
                                        <DescriptionIcon color="primary" />
                                        <Box>
                                          <Typography variant="body2">
                                            {uploadedFiles.pan.name}
                                          </Typography>
                                        </Box>
                                      </Box>
                                      <Box>
                                        <IconButton
                                          size="small"
                                          color="primary"
                                          onClick={() =>
                                            window.open(
                                              uploadedFiles.pan.url,
                                              "_blank",
                                            )
                                          }
                                          title="View PAN Card"
                                        >
                                          <VisibilityIcon />
                                        </IconButton>
                                        <IconButton
                                          size="small"
                                          color="error"
                                          onClick={() =>
                                            handleFileRemove("pan")
                                          }
                                          title="Remove File"
                                        >
                                          <DeleteIcon />
                                        </IconButton>
                                      </Box>
                                    </Box>
                                  ) : (
                                    <Button
                                      variant="outlined"
                                      component="label"
                                      fullWidth
                                      startIcon={<CloudUpload />}
                                      sx={{ color: "grey" }}
                                    >
                                      Upload PAN Card
                                      <input
                                        type="file"
                                        hidden
                                        accept=".pdf,.jpg,.jpeg,.png"
                                        ref={panFileInputRef}
                                        onChange={(e) =>
                                          handleFileUpload(e, "pan")
                                        }
                                      />
                                    </Button>
                                  )}
                                </Grid>

                                {/* TAN Number & Upload */}
                                <Grid item xs={12} md={6}>
                                  <Typography variant="subtitle1" gutterBottom>
                                    TAN Number (Optional)
                                  </Typography>
                                  <MDInput
                                    fullWidth
                                    {...register("tanNumber", {
                                      pattern: {
                                        value: /^[A-Z0-9]+$/,
                                        message:
                                          "Only alphanumeric characters are allowed",
                                      },
                                      onChange: (e) => {
                                        // Auto-uppercase and remove non-alphanumeric characters
                                        e.target.value = e.target.value
                                          .toUpperCase()
                                          .replace(/[^A-Z0-9]/g, "");
                                      },
                                    })}
                                    placeholder="Enter TAN Number"
                                    inputProps={{ maxLength: 10 }}
                                    style={{ textTransform: "uppercase" }}
                                  />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                  <Typography variant="subtitle1" gutterBottom>
                                    TAN Certificate (Optional)
                                  </Typography>
                                  {uploadedFiles.tan ? (
                                    <Box
                                      sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "space-between",
                                        p: 2,
                                        border: "1px solid #e0e0e0",
                                        borderRadius: 1,
                                        backgroundColor: "#f9f9f9",
                                      }}
                                    >
                                      <Box
                                        sx={{
                                          display: "flex",
                                          alignItems: "center",
                                          gap: 2,
                                        }}
                                      >
                                        <DescriptionIcon color="primary" />
                                        <Box>
                                          <Typography variant="body2">
                                            {uploadedFiles.tan.name}
                                          </Typography>
                                          {/* <Typography variant="caption" color="textSecondary">{uploadedFiles.tan.size}</Typography> */}
                                        </Box>
                                      </Box>
                                      <Box>
                                        <IconButton
                                          size="small"
                                          color="primary"
                                          onClick={() =>
                                            window.open(
                                              uploadedFiles.tan.url,
                                              "_blank",
                                            )
                                          }
                                          title="View TAN Certificate"
                                        >
                                          <VisibilityIcon />
                                        </IconButton>
                                        <IconButton
                                          size="small"
                                          color="error"
                                          onClick={() =>
                                            handleFileRemove("tan")
                                          }
                                          title="Remove File"
                                        >
                                          <DeleteIcon />
                                        </IconButton>
                                      </Box>
                                    </Box>
                                  ) : (
                                    <Button
                                      variant="outlined"
                                      component="label"
                                      fullWidth
                                      startIcon={<CloudUpload />}
                                      sx={{ color: "grey" }}
                                    >
                                      Upload TAN Document
                                      <input
                                        type="file"
                                        hidden
                                        accept=".pdf,.jpg,.jpeg,.png"
                                        ref={tanFileInputRef}
                                        onChange={(e) =>
                                          handleFileUpload(e, "tan")
                                        }
                                      />
                                    </Button>
                                  )}
                                  <Typography
                                    variant="caption"
                                    color="textSecondary"
                                    display="block"
                                    sx={{ mt: 1 }}
                                  >
                                    Supported formats: PDF, JPG, PNG (Max 5MB)
                                  </Typography>
                                </Grid>

                                {/* <Grid item xs={12}>
        <FormControlLabel
          control={
            <Checkbox
              {...register("bankDetails.verifyAccount", { required: 'Please verify the bank details' })}
              defaultChecked={false}
            />
          }
              label="Is Billing Entity?"
            /> */}
                                <Grid item xs={12}>
                                  <FormControlLabel
                                    control={
                                      <Controller
                                        defaultValue={false}
                                        name="isBillingEntity"
                                        control={control}
                                        render={({ field: props }) => (
                                          <Checkbox
                                            {...props}
                                            checked={props.value}
                                            {...register("isBillingEntity")}
                                            onChange={(e) =>
                                              props.onChange(e.target.checked)
                                            }
                                          />
                                        )}
                                      />
                                    }
                                    label="Is Billing Entity?"
                                  />
                                </Grid>
                              </Grid>
                              <Grid item xs={12} md={6}>
                                <FormControlLabel
                                  control={
                                    <Controller
                                      defaultValue={false}
                                      name="isGstRegistered"
                                      control={control}
                                      render={({ field: props }) => (
                                        <Checkbox
                                          {...props}
                                          checked={props.value}
                                          {...register("isGstRegistered")}
                                          onChange={(e) =>
                                            props.onChange(e.target.checked)
                                          }
                                        />
                                      )}
                                    />
                                  }
                                  label="Billing Address is GST Registered"
                                />
                                {/* <FormControlLabel
              control={
                <Checkbox
                  {...register("isGstRegistered")}
                  defaultChecked={false}
                />
              }
              label="Billing Address is GST Registered"
            /> */}
                              </Grid>
                              {/* </Grid> */}
                              {/* </Grid>
    </Grid> */}
                            </Card>

                            {/* Bank Details */}
                            <Card sx={{ p: 3, mb: 3 }}>
                              <Typography variant="h6" gutterBottom>
                                Bank Details
                              </Typography>
                              <Grid container spacing={3}>
                                {/* Bank Name & Branch Name */}
                                <Grid item xs={12} md={6}>
                                  <Typography variant="subtitle1" gutterBottom>
                                    Bank Name (Optional)
                                    {/* <span style={{ color: "red" }}>*</span> */}
                                  </Typography>
                                  <MDInput
                                    fullWidth
                                    {...register("bankName", {
                                      // required: isNewBranch ?'Bank Name is required':false,
                                      minLength: {
                                        value: 2,
                                        message:
                                          "Name must be at least 2 characters",
                                      },
                                      maxLength: {
                                        value: 100,
                                        message:
                                          "Name must be less than 100 characters",
                                      },
                                      // pattern: {
                                      //   value: /^[A-Za-z\s-]+$/,
                                      //   message: 'Only letters, spaces and hyphens are allowed'
                                      // },
                                      onChange: (e) => {
                                        // Allow only letters, spaces and hyphens
                                        e.target.value = e.target.value;
                                      },
                                    })}
                                    placeholder="Enter Bank Name"
                                    // error={!!errors?.bankName}
                                    // helperText={
                                    //   errors?.bankName?.message
                                    // }
                                  />
                                </Grid>

                                {/* Branch Name */}
                                <Grid item xs={12} md={6}>
                                  <Typography variant="subtitle1" gutterBottom>
                                    Branch Name (Optional)
                                    {/* <span style={{ color: "red" }}>*</span> */}
                                  </Typography>
                                  <MDInput
                                    fullWidth
                                    {...register("branchName", {
                                      // required: isNewBranch ?'Branch Name is required':false ,
                                      minLength: {
                                        value: 2,
                                        message:
                                          "Name must be at least 2 characters",
                                      },
                                      maxLength: {
                                        value: 100,
                                        message:
                                          "Name must be less than 100 characters",
                                      },
                                      // pattern: {
                                      //   value: /^[A-Za-z\s-]+$/,
                                      //   message: 'Only letters, spaces and hyphens are allowed'
                                      // },
                                      onChange: (e) => {
                                        // Allow only letters, spaces and hyphens
                                        e.target.value = e.target.value;
                                      },
                                    })}
                                    placeholder="Enter Branch Name"
                                    // error={!!errors.branchName}
                                    // helperText={errors.branchName || ' '}
                                  />
                                </Grid>

                                {/* Account Number & IFSC Code */}
                                <Grid item xs={12} md={6}>
                                  <Typography variant="subtitle1" gutterBottom>
                                    Account Number (Optional)
                                    {/* <span style={{ color: "red" }}>*</span> */}
                                  </Typography>
                                  <MDInput
                                    fullWidth
                                    type="number"
                                    {...register("accountNumber", {
                                      // required: isNewBranch ?'Account Number is required':false,
                                      min: {
                                        value: 0,
                                        message: "Invalid Account Number",
                                      },
                                    })}
                                    placeholder="Enter Account Number"
                                    sx={{
                                      flex: 1,
                                      "& input[type=number]::-webkit-inner-spin-button":
                                        {
                                          display: "none",
                                        },
                                      "& input[type=number]::-webkit-outer-spin-button":
                                        {
                                          display: "none",
                                        },
                                      "& input[type=number]": {
                                        MozAppearance: "textfield",
                                      },
                                    }}
                                    inputProps={{
                                      style: { textAlign: "left" },
                                    }}
                                    // error={!!errors?.accountNumber}
                                    // helperText={
                                    //   errors?.accountNumber?.message
                                    // }
                                  />
                                </Grid>

                                <Grid item xs={12} md={6}>
                                  <Typography variant="subtitle1" gutterBottom>
                                    IFSC Code (Optional)
                                    {/* <span style={{ color: "red" }}>*</span> */}
                                  </Typography>
                                  <MDInput
                                    fullWidth
                                    {...register("ifscCode", {
                                      // required: isNewBranch ?'IFSC Code is required':false,
                                      pattern: {
                                        value: /^[A-Z]{4}0[A-Z0-9]{6}$/,
                                        message: "Invalid IFSC Code format",
                                      },
                                    })}
                                    placeholder="Enter IFSC Code (e.g., HDFC0001234)"
                                    style={{ textTransform: "uppercase" }}
                                    // error={!!errors.ifscCode}
                                    // helperText={errors.ifscCode || ' '}
                                    inputProps={{
                                      maxLength: 11,
                                    }}
                                  />
                                </Grid>

                                {/* Cancel Cheque Upload */}
                                <Grid item xs={12} md={6}>
                                  <Typography variant="subtitle1" gutterBottom>
                                    Cancel Cheque (Optional)
                                    {/* <span style={{ color: "red" }}>*</span> */}
                                  </Typography>
                                  {uploadedFiles.cancelCheque ? (
                                    <Box
                                      sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "space-between",
                                        p: 2,
                                        border: "1px solid #e0e0e0",
                                        borderRadius: 1,
                                        backgroundColor: "#f9f9f9",
                                        // maxWidth: '500px'
                                      }}
                                    >
                                      <Box
                                        sx={{
                                          display: "flex",
                                          alignItems: "center",
                                          gap: 2,
                                        }}
                                      >
                                        <DescriptionIcon color="primary" />
                                        <Box>
                                          <Typography variant="body2">
                                            {uploadedFiles.cancelCheque.name}
                                          </Typography>
                                          {/* <Typography variant="caption" color="textSecondary">{uploadedFiles.cancelCheque.size}</Typography> */}
                                        </Box>
                                      </Box>
                                      <Box>
                                        <IconButton
                                          size="small"
                                          color="primary"
                                          onClick={() =>
                                            window.open(
                                              uploadedFiles.cancelCheque.url,
                                              "_blank",
                                            )
                                          }
                                          title="View Cancel Cheque"
                                        >
                                          <VisibilityIcon />
                                        </IconButton>
                                        <IconButton
                                          size="small"
                                          color="error"
                                          onClick={() =>
                                            handleFileRemove("cancelCheque")
                                          }
                                          title="Remove File"
                                        >
                                          <DeleteIcon />
                                        </IconButton>
                                      </Box>
                                    </Box>
                                  ) : (
                                    <Button
                                      variant="outlined"
                                      component="label"
                                      fullWidth
                                      startIcon={<CloudUpload />}
                                      sx={{ color: "grey" }}
                                      // sx={{ maxWidth: '500px' }}
                                    >
                                      Upload Cancel Cheque
                                      <input
                                        type="file"
                                        hidden
                                        accept=".pdf,.jpg,.jpeg,.png"
                                        ref={cancelChequeRef}
                                        onChange={(e) =>
                                          handleFileUpload(e, "cancelCheque")
                                        }
                                      />
                                    </Button>
                                  )}
                                  <Typography
                                    variant="caption"
                                    color="textSecondary"
                                    display="block"
                                    sx={{ mt: 1, maxWidth: "500px" }}
                                  >
                                    Supported formats: PDF, JPG, PNG (Max 5MB)
                                  </Typography>
                                </Grid>

                                {/* <Grid item xs={12}>
        <FormControlLabel
          control={
            <Checkbox
              {...register("bankDetails.verifyAccount", { required: 'Please verify the bank details' })}
              defaultChecked={false}
            />
          }
          label="I verify that the bank account details provided are correct"
        />
      </Grid> */}
                              </Grid>
                            </Card>

                            {/* Contract Information */}
                            <Card sx={{ p: 3, mb: 3 }}>
                              <Box
                                sx={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                  mb: 2,
                                }}
                              >
                                <Typography variant="h6">
                                  Contract Information
                                </Typography>
                                <Button
                                  variant="contained"
                                  color="primary"
                                  size="small"
                                  startIcon={<AddIcon />}
                                  onClick={() =>
                                    appendContract({
                                      contractStartDate: null,
                                      contractEndDate: null,
                                      contractCopy: { fileUrl: "" },
                                      isActive: false,
                                    })
                                  }
                                >
                                  Add Contract
                                </Button>
                              </Box>

                              {contractFields.map((field, index) => {
                                const isActive = getValues(
                                  `contractDetails.${index}.isActive`,
                                );
                                return (
                                  <Box
                                    key={field.id}
                                    sx={{
                                      mb: 4,
                                      p: 2,
                                      border: "1px solid #eee",
                                      borderRadius: 1,
                                      position: "relative",
                                      borderLeft: isActive
                                        ? "4px solid #4caf50"
                                        : "1px solid #eee",
                                      boxShadow: isActive
                                        ? "0 0 10px rgba(76, 175, 80, 0.2)"
                                        : "none",
                                    }}
                                  >
                                    <Box
                                      sx={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        mb: 1,
                                      }}
                                    >
                                      {isActive ? (
                                        <Box
                                          sx={{
                                            display: "flex",
                                            alignItems: "center",
                                            gap: 1,
                                          }}
                                        >
                                          <Typography
                                            variant="body2"
                                            sx={{ ml: 0 }}
                                          >
                                            Contract {index + 1}
                                          </Typography>
                                          <CheckCircleIcon
                                            sx={{ ml: 1 }}
                                            color="success"
                                          />
                                          <Typography
                                            variant="body2"
                                            color="#4caf50"
                                            sx={{ ml: 1 }}
                                          >
                                            Active
                                          </Typography>
                                        </Box>
                                      ) : (
                                        <Box
                                          sx={{
                                            display: "flex",
                                            alignItems: "center",
                                          }}
                                        >
                                          <Typography
                                            variant="body2"
                                            sx={{ ml: 0 }}
                                          >
                                            Contract {index + 1}
                                          </Typography>
                                        </Box>
                                      )}
                                      <div style={{ marginLeft: "auto" }}>
                                        <IconButton
                                          size="small"
                                          color="error"
                                          onClick={() => removeContract(index)}
                                          title="Remove Contract"
                                        >
                                          <DeleteIcon fontSize="small" />
                                        </IconButton>
                                      </div>
                                    </Box>

                                    <Grid container spacing={3}>
                                      <Grid item xs={12} md={6}>
                                        <Typography
                                          variant="subtitle1"
                                          gutterBottom
                                        >
                                          Contract Start Date{" "}
                                          <span style={{ color: "red" }}>
                                            *
                                          </span>
                                        </Typography>

                                        <Controller
                                          name={`contractDetails.${index}.contractStartDate`}
                                          control={control}
                                          rules={{
                                            validate: (value) => {
                                              const endDate = getValues(
                                                `contractDetails.${index}.contractEndDate`,
                                              );
                                              if (
                                                value &&
                                                endDate &&
                                                new Date(value) >=
                                                  new Date(endDate)
                                              ) {
                                                return "Start date must be before end date";
                                              }
                                              return true;
                                            },
                                          }}
                                          render={({
                                            field,
                                            fieldState: { error },
                                          }) => (
                                            <LocalizationProvider
                                              dateAdapter={AdapterDayjs}
                                            >
                                              <DatePicker
                                                {...field}
                                                // minDate={new Date()}
                                                onChange={(newValue) => {
                                                  field.onChange(newValue);
                                                  // Trigger validation of both fields when start date changes
                                                  trigger([
                                                    `contractDetails.${index}.contractStartDate`,
                                                    `contractDetails.${index}.contractEndDate`,
                                                  ]);
                                                }}
                                                renderInput={(params) => (
                                                  <TextField
                                                    {...params}
                                                    fullWidth
                                                    error={!!error}
                                                    helperText={error?.message}
                                                  />
                                                )}
                                              />
                                            </LocalizationProvider>
                                          )}
                                        />
                                      </Grid>

                                      <Grid item xs={12} md={6}>
                                        <Typography
                                          variant="subtitle1"
                                          gutterBottom
                                        >
                                          Contract End Date{" "}
                                          <span style={{ color: "red" }}>
                                            *
                                          </span>
                                        </Typography>
                                        <Controller
                                          name={`contractDetails.${index}.contractEndDate`}
                                          control={control}
                                          rules={{
                                            validate: (value) => {
                                              const startDate = getValues(
                                                `contractDetails.${index}.contractStartDate`,
                                              );
                                              if (
                                                startDate &&
                                                value &&
                                                new Date(value) <=
                                                  new Date(startDate)
                                              ) {
                                                return "End date must be after start date";
                                              }
                                              return true;
                                            },
                                          }}
                                          render={({
                                            field,
                                            fieldState: { error },
                                          }) => (
                                            <LocalizationProvider
                                              dateAdapter={AdapterDayjs}
                                            >
                                              <DatePicker
                                                {...field}
                                                minDate={
                                                  getValues(
                                                    `contractDetails.${index}.contractStartDate`,
                                                  ) || new Date()
                                                }
                                                onChange={(newValue) => {
                                                  field.onChange(newValue);
                                                  // Trigger validation of both fields when end date changes
                                                  trigger([
                                                    `contractDetails.${index}.contractStartDate`,
                                                    `contractDetails.${index}.contractEndDate`,
                                                  ]);
                                                }}
                                                renderInput={(params) => (
                                                  <TextField
                                                    {...params}
                                                    fullWidth
                                                    error={!!error}
                                                    helperText={error?.message}
                                                  />
                                                )}
                                              />
                                            </LocalizationProvider>
                                          )}
                                        />
                                      </Grid>

                                      <Grid item xs={12}>
                                        <Typography
                                          variant="subtitle1"
                                          gutterBottom
                                        >
                                          Contract Document{" "}
                                          <span style={{ color: "red" }}>
                                            *
                                          </span>
                                        </Typography>
                                        {uploadedFiles[`contract_${index}`] ? (
                                          <Box
                                            sx={{
                                              display: "flex",
                                              alignItems: "center",
                                              justifyContent: "space-between",
                                              p: 2,
                                              border: "1px solid #e0e0e0",
                                              borderRadius: 1,
                                              backgroundColor: "#f9f9f9",
                                            }}
                                          >
                                            <Box
                                              sx={{
                                                display: "flex",
                                                alignItems: "center",
                                                gap: 2,
                                              }}
                                            >
                                              <DescriptionIcon color="primary" />
                                              <Box>
                                                <Typography variant="body2">
                                                  {
                                                    uploadedFiles[
                                                      `contract_${index}`
                                                    ].name
                                                  }
                                                </Typography>
                                              </Box>
                                            </Box>
                                            <Box>
                                              <IconButton
                                                size="small"
                                                color="primary"
                                                onClick={() =>
                                                  window.open(
                                                    uploadedFiles[
                                                      `contract_${index}`
                                                    ].url,
                                                    "_blank",
                                                  )
                                                }
                                                title="View Contract"
                                              >
                                                <VisibilityIcon />
                                              </IconButton>
                                              <IconButton
                                                size="small"
                                                color="error"
                                                onClick={() =>
                                                  handleFileRemove(
                                                    `contract_${index}`,
                                                  )
                                                }
                                                title="Remove File"
                                              >
                                                <DeleteIcon />
                                              </IconButton>
                                            </Box>
                                          </Box>
                                        ) : (
                                          <Controller
                                            name={`contractDetails.${index}.contractCopy`}
                                            control={control}
                                            rules={{
                                              required: isNewBranch
                                                ? "Contract Document is required"
                                                : false,
                                              validate: {
                                                fileRequired: () =>
                                                  !uploadedFiles[
                                                    `contract_${index}`
                                                  ]
                                                    ? "Contract Document is required"
                                                    : true,
                                              },
                                            }}
                                            render={({
                                              field: {
                                                onChange,
                                                value,
                                                ...field
                                              },
                                              fieldState: { error },
                                            }) => (
                                              <>
                                                <Button
                                                  variant="outlined"
                                                  component="label"
                                                  fullWidth
                                                  startIcon={<CloudUpload />}
                                                  sx={{
                                                    color: "grey",
                                                    borderColor: error
                                                      ? "error.main"
                                                      : "rgba(0, 0, 0, 0.23)",
                                                  }}
                                                >
                                                  Upload Contract
                                                  <input
                                                    type="file"
                                                    hidden
                                                    accept=".pdf,.jpg,.jpeg,.png"
                                                    onChange={(e) => {
                                                      const file =
                                                        e.target.files[0];
                                                      if (file) {
                                                        handleFileUpload(
                                                          e,
                                                          `contract_${index}`,
                                                        );
                                                        // The actual file URL will be set in the handleFileUpload function
                                                      }
                                                    }}
                                                  />
                                                </Button>
                                                {error && (
                                                  <Typography
                                                    color="error"
                                                    variant="caption"
                                                    display="block"
                                                    sx={{ mt: 0.5, ml: 1.5 }}
                                                  >
                                                    {error.message}
                                                  </Typography>
                                                )}
                                              </>
                                            )}
                                          />
                                        )}
                                        <Typography
                                          variant="caption"
                                          color="textSecondary"
                                          display="block"
                                          sx={{ mt: 1 }}
                                        >
                                          Supported formats: PDF, JPG, PNG (Max
                                          5MB)
                                        </Typography>
                                      </Grid>
                                    </Grid>
                                  </Box>
                                );
                              })}
                            </Card>

                            {/* Additional Fees & Discounts */}
                            <Card sx={{ p: 3, mb: 3 }}>
                              <Typography variant="h6" gutterBottom>
                                Additional Fees & Discounts
                              </Typography>
                              <Grid container spacing={3}>
                                <Grid item xs={12}>
                                  <FormControlLabel
                                    control={
                                      <Controller
                                        defaultValue={false}
                                        name="isOneTimeFee"
                                        control={control}
                                        render={({ field: props }) => (
                                          <Checkbox
                                            {...props}
                                            checked={!!props.value}
                                            {...register("isOneTimeFee")}
                                            onChange={(e) => {
                                              console.log(
                                                "e.target.checked",
                                                e.target.checked,
                                              );
                                              props.onChange(e.target.checked);
                                              setisOneTimeFee(e.target.checked);
                                            }}
                                          />
                                        )}
                                      />
                                    }
                                    label="One Time Fee"
                                  />
                                  {/* <FormControlLabel
          control={
            <Checkbox
              checked={!!watch("isOneTimeFee")}
              onChange={(e) => setValue("isOneTimeFee", e.target.checked, { shouldValidate: true })}
              color="primary"
            />
          }
          label="One Time Fee"
        /> */}
                                </Grid>

                                {isOneTimeFee && (
                                  <Grid item xs={12} md={6}>
                                    <Typography
                                      variant="subtitle1"
                                      gutterBottom
                                    >
                                      One Time Fee Amount (₹){" "}
                                      <span style={{ color: "red" }}>*</span>
                                    </Typography>
                                    <MDInput
                                      fullWidth
                                      type="number"
                                      defaultValue={""} // Set default value to 0
                                      {...register("oneTimeFeeAmount", {
                                        validate: (value) => {
                                          // Only validate if isOneTimeFee is true
                                          if (isOneTimeFee) {
                                            if (
                                              value === undefined ||
                                              value === null ||
                                              value === ""
                                            ) {
                                              return "One Time Fee Amount is required";
                                            }
                                            if (Number(value) < 0) {
                                              // Changed <= to < since 0 is now allowed
                                              return "Amount must be 0 or greater";
                                            }
                                          }
                                          return true;
                                        },
                                        valueAsNumber: true,
                                      })}
                                      placeholder="0"
                                      // error={!!errors?.oneTimeFeeAmount}
                                      // helperText={errors?.oneTimeFeeAmount?.message}
                                      InputProps={{
                                        startAdornment: (
                                          <InputAdornment position="start">
                                            ₹
                                          </InputAdornment>
                                        ),
                                        inputProps: { min: 0 },
                                      }}
                                      sx={{
                                        flex: 1,
                                        "& input[type=number]::-webkit-inner-spin-button":
                                          {
                                            display: "none",
                                          },
                                        "& input[type=number]::-webkit-outer-spin-button":
                                          {
                                            display: "none",
                                          },
                                        "& input[type=number]": {
                                          MozAppearance: "textfield",
                                        },
                                      }}
                                      inputProps={{
                                        style: { textAlign: "left" },
                                      }}
                                      onKeyPress={(e) => {
                                        // Prevent negative numbers from being typed
                                        if (e.key === "-" || e.key === "e") {
                                          e.preventDefault();
                                        }
                                      }}
                                      onPaste={(e) => {
                                        // Prevent pasting negative numbers
                                        const pasteData =
                                          e.clipboardData.getData("text/plain");
                                        if (
                                          pasteData.startsWith("-") ||
                                          isNaN(pasteData)
                                        ) {
                                          e.preventDefault();
                                        }
                                      }}
                                    />

                                    {/* {errors.oneTimeFeeAmount && (
            <Typography color="error" variant="caption">
              {errors.oneTimeFeeAmount.message}
            </Typography>
          )} */}
                                  </Grid>
                                )}

                                <Grid item xs={12} md={6}>
                                  <Typography variant="subtitle1" gutterBottom>
                                    Discount Coupon(Optional)
                                  </Typography>
                                  <MDInput
                                    fullWidth
                                    {...register("discountCoupon")}
                                    placeholder="Enter Discount Coupon"
                                  />
                                </Grid>

                                {/* <Grid item xs={12}>
        <Typography variant="subtitle1" gutterBottom>Notes</Typography>
        <MDInput
          fullWidth
          multiline
          rows={3}
          {...register("fees.notes")}
          placeholder="Any additional notes about fees or discounts"
        />
      </Grid> */}
                              </Grid>
                            </Card>

                            {/* Active Status */}
                            <Card sx={{ p: 3, mb: 3 }}>
                              <Typography variant="h6" gutterBottom>
                                Branch status
                              </Typography>

                              <FormControlLabel
                                control={
                                  // <Controller
                                  //   defaultValue={false}
                                  //   name="branchActivated"
                                  //   control={control}
                                  //   render={({ field: props }) => (
                                  //     <Checkbox
                                  //       {...props}
                                  //       checked={!props.value}
                                  //       {...register("branchActivated")}
                                  //       onChange={(e) =>
                                  //         props.onChange(!e.target.checked)
                                  //       }
                                  //     />
                                  //   )}
                                  // />
                                  <Controller
                                    name="branchInactive"
                                    control={control}
                                    render={({
                                      field: { value, onChange, ...field },
                                    }) => (
                                      <FormControlLabel
                                        control={
                                          <Checkbox
                                            {...field}
                                            checked={value} // Invert the value for display
                                            onChange={(e) =>
                                              onChange(e.target.checked)
                                            } // Invert on change
                                          />
                                        }
                                        label="Inactivate Branch"
                                      />
                                    )}
                                  />
                                }
                                label=""
                              />
                              {/* <FormControlLabel
      control={
        <Checkbox
          checked={("branchActivated")}
          onChange={(e) => setValue("branchActivated", e.target.checked, { shouldValidate: true })}
          color="primary"
        />
      }
      label={
        <Box>
          <Typography variant="subtitle1">Is Active</Typography>
        </Box>
      }
    /> */}
                            </Card>

                            {/* Save/Cancel Buttons */}
                            {/* <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
    <MDButton
      variant="gradient"
      color="info"
      type="submit"
      sx={{ mr: 2 }}
    >
      Save Changes
    </MDButton>
    <MDButton
      variant="outlined"
      color="secondary"
      onClick={handleBack}
    >
      Cancel
    </MDButton>
  </Box> */}

                            <div style={{ marginTop: "2rem" }}>
                              <Button
                                type="submit"
                                variant="contained"
                                sx={{ color: "#fff" }}
                              >
                                Save
                              </Button>
                            </div>
                          </TabPanel>
                          <div>
                            {/* Error Modal - Keep existing modal for errors only */}
                            {showModal && (
                              <div
                                style={{
                                  position: "fixed",
                                  top: 0,
                                  left: 0,
                                  right: 0,
                                  bottom: 0,
                                  backgroundColor: "rgba(0, 0, 0, 0.5)",
                                  backdropFilter: "blur(4px)",
                                  WebkitBackdropFilter: "blur(4px)",
                                  zIndex: 9999,
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                }}
                                // onClick={closeModal}
                              >
                                <div
                                  style={{
                                    backgroundColor: "white",
                                    borderRadius: "12px",
                                    width: "90%",
                                    maxWidth: "500px",
                                    maxHeight: "90vh",
                                    overflowY: "auto",
                                    padding: "20px",
                                    boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                                  }}
                                  onClick={(e) => e.stopPropagation()}
                                >
                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "flex-end",
                                    }}
                                  >
                                    <button
                                      onClick={closeModal}
                                      style={{
                                        background: "none",
                                        border: "none",
                                        cursor: "pointer",
                                        fontSize: "20px",
                                        color: "#6B7280",
                                      }}
                                    >
                                      ✕
                                    </button>
                                  </div>
                                  <div
                                    style={{
                                      textAlign: "center",
                                      padding: "20px",
                                    }}
                                  >
                                    {modalType === "error" ||
                                    modalType === "error_email" ||
                                    modalType === "error_date" ? (
                                      <div
                                        style={{
                                          width: "64px",
                                          height: "64px",
                                          backgroundColor: "#FEE2E2",
                                          borderRadius: "50%",
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "center",
                                          margin: "0 auto 16px",
                                          color: "red",
                                          fontSize: "20px",
                                        }}
                                      >
                                        !
                                      </div>
                                    ) : (
                                      <CheckCircleIcon
                                        color="success"
                                        sx={{ width: "55px", height: "55px" }}
                                      />
                                    )}
                                    <h3
                                      style={{
                                        fontSize: "20px",
                                        fontWeight: 600,
                                        color: "#111827",
                                        marginBottom: "12px",
                                      }}
                                    >
                                      {modalType === "error"
                                        ? "Branch Not Activated"
                                        : modalType === "success"
                                          ? "Branch Activated"
                                          : modalType === "error_email"
                                            ? "Missing Information"
                                            : modalType === "error_date"
                                              ? "Contract Date is Invalid"
                                              : "Branch Inactivated"}
                                    </h3>
                                    <p
                                      style={{
                                        color: "#4B5563",
                                        fontSize: "14px",
                                        lineHeight: "1.5",
                                        marginBottom: "24px",
                                      }}
                                    >
                                      {modalMessage}
                                    </p>
                                    <button
                                      onClick={closeModal}
                                      style={{
                                        backgroundColor: "#3B82F6",
                                        color: "white",
                                        border: "none",
                                        borderRadius: "6px",
                                        padding: "8px 24px",
                                        fontSize: "14px",
                                        fontWeight: 500,
                                        cursor: "pointer",
                                      }}
                                    >
                                      OK
                                    </button>
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>

                          <div style={{ marginTop: "2rem" }}>
                            {/* <Button
    type="submit"
    variant="contained"
    sx={{ color: "#fff" }}
  >
    Save
  </Button> */}

                            {/* <Button
    type="submit"
    variant="contained"
    sx={{ color: "#fff" }}
  >
    {" "}
    Save
  </Button> */}
                          </div>
                        </div>
                      </>
                    );
                  })}
              </form>
            </DialogContent>
          </MDBox>
        ) : (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              marginBottom: "24%",
              marginTop: "20%",
            }}
          >
            <CircularProgress disableShrink />
          </div>
        )}
      </DashboardLayout>

      <ConfirmDialog
        open={openConfirm}
        title="Confirm Change"
        message={confirmMessage}
        onConfirm={handleConfirm}
        onCancel={handleCancel}
      />
    </>
  );
};
export default BranchUserForm;
